import {
  compassImageUrl,
  courtImageUrl,
  lightBulbImageUrl,
  lightningImageUrl,
  peopleImageImageUrl,
  shuffleImageUrl,
  TmiType,
} from '@app/app/page-modules/personality-indicator/pi-questions/models/pi-questions.model';

export const tmiTypesReportCy: {
  [trait: string]: TmiType;
} = {
  ENFJ: {
    shortDescription: 'Rhoi',
    atWorkParagraphs: {
      effectiveness: [
        'Gosod pwyslais uwch ar gwblhau tasgau',
        'Bod yn fwy chwilfrydig, amheus a beirniadol',
        'Bod yn llai teyrngar i bobl neu achosion nad ydynt yn haeddu hynny',
        'Ymddwyn yn sydyn yn amlach',
        'Bod yn llai gorchymynol tuag at bobl y maent yn poeni amdanynt, gan ganiatáu iddynt wneud eu camgymeriadau eu hunain a dysgu ohonynt',
        'Treulio llai o amser ar faterion rhyngbersonol',
        'Adeiladu ar eu cryfder i ddarparu strwythur a threfn i’w tîm',
        'Adeiladu ar eu cryfder i gyflawni cytundeb trwy eglurhad, cydweithrediad a chydweithio',
        'Sylweddoli nad yw damcaniaeth bob amser yn gweithio',
        'Canolbwyntio ar yr pethau cadarnhaol yn hytrach na’r negyddol',
        'Cydnabod bod weithiau’n rhaid gwneud penderfyniadau gyda gwybodaeth anghyflawn',
      ],
      teamLeader: [
        'Egni a ysbrydoli’r tîm gyda brwdfrydedd a hiwmor',
        'Yn meddu ar arddull arweinyddiaeth gyfartal',
        'Rhoi pwysau cyfartal ar y broses yn ogystal â’r cynnwys',
        'Creu trefn glir i’r tîm',
        'Sicrhau bod y tîm ar y trywydd iawn drwy ddefnyddio agendas, amserlenni a chyflawniadau tasgau',
        'Gwrando ar bob aelod o’r tîm a ystyried pob barn',
        'Hawdddysgu cydweithrediad ac defnyddio adnoddau’r tîm yn effeithiol',
        'Arwain eu tîm trwy mewnwelediad a sensitifrwydd',
      ],
      conflicts: [
        'Maent yn debygol o gael eu rhwystro gan aelodau’r tîm sy’n dod heb fod yn barod i gyfarfodydd',
        'Efallai y bydd gwrthdaro gyda phobl y maent yn eu hystyried yn ddiymdrech i ddatrys problemau’r tîm',
        'Llai tebygol o ddod i ben gyda phobl sy’n dangos disrespekt am amser eraill trwy ddod yn hwyr a gadael yn gynnar',
        'Gallai gwrthdaro’n fwy tebygol gyda phobl nad ydynt yn gwneud digon o ymdrech i gydweithredu',
        'Efallai y bydd ganddynt goddefgarwch isel tuag at bobl nad ydynt yn ystyried effaith eu penderfyniadau ar eraill',
        'Gallai gael eu poeni’n fwy gan bobl nad ydynt yn caniatáu digon o amser ar gyfer cyfnewid pleidiol rhyngbersonol',
      ],
      stressAdvisor: [
        'Yn dod yn fwy beirniadol ac yn dod o hyd i gamgymeriadau ym mhob peth',
        'Yn dod yn ffocysu ar sicrhau eu bod yn hoff iawn gan bawb ac i ennill eu cymeradwyaeth',
        'Yn dod yn oruchwyliol gyda’r angen i drefnu popeth',
      ],
      workEnvironment: [
        'Yn well ganddynt amgylchedd prysur, rhyngweithiol ac yn ceisio cytgord',
        'Yn well ganddynt gael cynllun, trefn a chadw atynt',
      ],
      underStress: [],
      underSevereStress: [],
    },
    atWorkTagLine: 'Yn egni a ysbrydoli’r tîm gyda brwdfrydedd a hiwmor',
    atWorkSneakPeek: 'Un ffordd y gallent wella eu heffeithlonrwydd yn y gwaith yw bod yn fwy chwilfrydig, amheus a beirniadol',
    withOthersTagLine: 'Allanol, cyfeillgar a chymdeithasol',
    withOthersSneakPeek:
      '%fname efallai’n teimlo’n fwy cyfforddus yn cymryd y rolau canlynol yn eu tîm: Y Trefnydd, Y Generydd Syniadau, Y Cyfryngwr',
    withOthersParagraphs: {
      strengths: [
        'Allanol, cyfeillgar a chymdeithasol',
        'Poblogaidd, cydymdeimladol',
        'Mynegiannol',
        'Yn rhoi annog a phrydferthwch yn rhydd',
        'Mwynhau cyfnewid sgwrs fer',
        'Arddull unigol ond bob amser yn meddwl am y grŵp',
      ],
      weakSpotsWithOthers: [
        'Gormwys i wrthdaro',
        'Efallai angen annog a chydnabyddiaeth',
        'Efallai angen amser ar gyfer cyfnewid pleidiol rhyngbersonol',
        'Gall weld beirniadaeth lle nad oedd un wedi ei fwriadu',
        'Anfeddwl i ymddwyn yn sydyn',
      ],
    },
    typeTagLine: 'Gall dod o hyd i batrymau a ystyr tu ôl i’r wyneb',
    typeSneakPeek: "Mae math %fname yn cael ei alw'n ENFJ. Mae rhai allweddair cysylltiedig yn garedig, cytbwys, a catalydd.",
    typeKeywords: [
      '1. Cydweithredol',
      '2. Cydymdeimladol',
      '3. Chwilio am hunan',
      '4. Catalydd',
      '5. Adeiladwr perthynas',
      '6. Posibiliadau',
      '7. Trugarog',
      '8. Trefnus',
      '9. Sylw i fanylion',
      '10. Cytgord',
      '11. Sensitif',
    ],
    typePersonalStrengths: [
      'Gall dod o hyd i batrymau a ystyr tu ôl i’r wyneb',
      'Da wrth hwyluso cyfathrebu',
      'Creadigol, gyda dychymyg cryf',
      'Ymagwedd gyfrifol tuag at waith',
      'Da wrth gyflwyno',
      'Da wrth arwain trafodaethau gyda rhwyddineb a tact',
      'Yn ymateb i ganmoliaeth a beirniadaeth',
      'Dibynadwy, dibynadwy a theyrngar',
      'Da wrth sylw i fanylion a threfnu’r byd o’u cwmpas',
      'Yn frwdfrydig am weithio dros les cyffredinol, cydweithiwr naturiol',
      'Cynnes, sensitif, deallus ac empathig',
      'Gall cyflawni pethau',
      'Yn sensitif iawn i emosiynau, anghenion a symudiadau eraill',
      'Yn awyddus i ddatgelu’r gorau ym mhawb',
      'Gall tynnu ar gysyniadau damcaniaethol mewn modd trefnus a methodol',
      'Dealltwriaeth gadarn o gysyniadau damcaniaethol a egwyddorion sylfaenol',
      'Gall mynd i’r afael â phroblemau mewn ffordd systematig',
    ],
    typeWeakSpots: [
      'Yn casáu anghytgord a gwrthdaro',
      'Nid yw goruchwylio eraill yn hawdd',
      'Yn well ganddynt rôl tîm diffiniedig',
      'Gall weithiau golli golwg ar faterion ymarferol',
      'Gall deimlo’n brifo neu gael ei wrthod yn hawdd',
    ],
    description:
      'Mae’r ENFJ yn unigolyn brwdfrydig, personol ac ymatebol gyda ffocws cryf ar berthnasoedd a rhyngweithio. Wrth geisio dod o hyd i gytgord credant yn gryf mewn pobl, weithiau hyd yn oed i draul. Mae’r ENFJ yn gynnes ac altruistig, llawn charisma ac yn gallu gwneud i bobl ddilyn eu harweiniad. Maent yn gyfathrebwyr naturiol a hawdd sy’n sefyll i’r hyn y credant ynddo. Dibynadwy ac wedi eu trefnu maent am gyflawni, ond heb golli golwg ar anghenion eraill.',
    individualTypeByLetters: 'Rhoi',
    individualDescription:
      'Fel Rhoddwr, maent yn debygol o fod yn unigolyn brwdfrydig, personol ac ymatebol gyda ffocws cryf ar berthnasoedd a rhyngweithio. Wrth geisio dod o hyd i gytgord credant yn gryf mewn pobl, weithiau hyd yn oed i draul. Maent yn debygol o fod yn gynnes ac altruistig, llawn charisma ac yn gallu gwneud i bobl ddilyn eu harweiniad. Maent yn debygol o fod yn gyfathrebwyr naturiol a hawdd sy’n sefyll i’r hyn y credant ynddo. Dibynadwy ac wedi eu trefnu maent am gyflawni, ond yn sicrhau nad yw hyn heb golli golwg ar anghenion eraill.',
  },

  ENFP: {
    shortDescription: 'Ysbryderydd',
    atWorkParagraphs: {
      effectiveness: [
        'Peidio â phoeni gormod am benderfyniadau personol',
        'Cofio y gall gweithredu eu syniadau fod yn fwy cymhleth ac yn cymryd mwy o amser na meddwl am y syniadau hynny',
        'Bod yn fwy pragmatig',
        'Holio eu mewnwelediadau intuitif eu hunain yn amlach',
        'Sicrhau nad ydynt wedi hepgor rhai ffeithiau allweddol',
        'Gwrando’n fwy gofalus ar aelodau tawel eu tîm',
        'Datblygu eu hyder mewn dweud pethau',
        'Cymer stance mwy beirniadol tuag at safbwyntiau eraill',
        'Cymryd digon o amser i ystyried a myfyrio cyn mynd i weithredu',
        'Ceisio dweud “na” yn amlach',
        'Peidio â derbyn beirniadaeth yn bersonol',
        'Sicrhau nad ydynt yn addo mwy nag sydd yn rhesymol neu bosibl i’w gyflawni',
        'Bod yn ofalus i beidio â chael y tîm i’r trywydd anghywir trwy fod yn rhy siaradus neu roi syniadau’n ar hap',
      ],
      teamLeader: [
        'Ysbrydoli eraill gyda’u brwdfrydedd',
        'Sicrhau bod pob llais yn y tîm yn cael ei glywed a’i ddeall. Negodi’n ofalus rhwng barn wahanol yn eu tîm',
        'Pwysleisio ardaloedd o gytundeb a sicrhau cytundeb cyffredinol',
        'Datblygu perthnasoedd personol gyda phob aelod o’r tîm',
        'Galluogi aelodau’r tîm i rannu, cydnabod a dilysu eu cyfraniadau',
        'Cais am syniadau a gweledigaethau gan bawb yn y tîm wrth ddatblygu strategaethau ar gyfer y dyfodol',
        'Cynnig amgen cadarnhaol i’w ystyried yn y broses gwneud penderfyniadau',
        'Ceisio dod o hyd i gyfleoedd datblygu i bob aelod o’r tîm',
      ],
      conflicts: [
        'Gall gwrthdaro gyda aelodau’r tîm y maent yn eu hystyried yn canolbwyntio rhy gul',
        'Gall gael eu rhwystro gan bobl sy’n ymddangos yn negyddol neu’n barhaus yn beirniadol',
        'Llai tebygol o ddod i ben gyda phobl sydd, yn eu barn nhw, yn canolbwyntio’n ormodol ar fanylion',
        'Gallai cael eu rhwystro gan bobl nad ydynt yn cynnwys pawb yn y broses tîm',
        'Tebygol o gael eu rhwystro gan bobl sy’n treulio gormod o amser yn dadlau am yr hyn sydd angen ei gyflawni',
      ],
      stressAdvisor: [
        'Gall fod yn anodd dweud “na”',
        'Gall ymgymryd â gormod o brosiectau heb ffordd ymarferol o’u cwblhau',
        'O dan straen difrifol gall ddod yn anodd tynnu’n ôl o brosiect i fynd i anghenion ymarferol neu corfforol',
      ],
      workEnvironment: [
        'Amgylchedd rhyngweithiol, cymdeithasol',
        'Gweithio tuag at rywbeth ystyrlon a defnyddio eu dychymyg a chreadigrwydd',
      ],
      underStress: [
        'Gall ddod yn fwy osgoi manylion a chael ei ddryslyd gan y ffeithiau',
        'Tebygol o dynnu’n ôl ac ymatal o sefyllfa, gan ddod yn negyddol ac yn beirniadol',
        'Cael ei chael yn anodd canolbwyntio a dilyn gweithdrefnau rheolaidd',
      ],
      underSevereStress: ['O dan straen difrifol, mae’n anodd tynnu’n ôl o brosiect i fynd i anghenion ymarferol neu corfforol'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gall %fname wella eu heffeithlonrwydd yn y gwaith yw peidio â phoeni gormod am benderfyniadau personol',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      '%fname efallai’n teimlo’n fwy cyfforddus wrth gymryd y rolau canlynol mewn tîm: Y Generydd Syniadau, Y Cyfryngwr, neu Y Trawsfforddwr Ffiniau',
    withOthersParagraphs: {
      strengths: [
        'Cymdeithasol ac allanol',
        'Hawdd i’w hoffi, poblogaidd',
        'Dangos diddordeb mawr yn y bobl o’u cwmpas',
        'Yn cael ei ddisgrifio fel unigolyn cynnes, empathig a gofalus',
        'Yn gwerthuso safbwyntiau eraill gyda sensitifrwydd a tact',
        'Yn gwneud ffrindiau’n hawdd',
        'Yn rhyddfeddwl ac agored i feddwl',
        'Cytbwys',
        'Yn addasu',
        'Yn gwerthfawrogi uniondeb yn uchel',
      ],
      weakSpotsWithOthers: [
        'Gall fod yn anodd wynebu eraill',
        'Gall addasu i eraill ar ei draul ei hun',
        'Gall ddod yn dicach os credant eu bod wedi cael eu cam-drin',
        'Gall ddod yn ddigalon os nad yw eu syniadau a barn yn cael eu gwerthfawrogi',
        'Gall eraill eu hystyried ychydig yn ddiddrefnus',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "Mae math %fname yn cael ei alw'n ENFP. Mae rhai allweddair cysylltiedig yn frwdfrydig, gweledol, neu gynnes.",
    typeKeywords: [
      '1. Brwdfrydig',
      '2. Egniol',
      '3. Cefnogol',
      '4. Cymdeithasol',
      '5. Gweledol',
      '6. Yn canolbwyntio ar bobl',
      '7. Creadigol',
      '8. Gofalgar',
      '9. Cynnes',
      '10. Cydymdeimladol',
      '11. Sydyn',
      '12. Hyblyg',
    ],
    typePersonalStrengths: [
      'Yn egniol ac yn ysgogi eraill',
      'Yn gweld bywyd fel llawn posibiliadau',
      'Hwyluso cyfathrebu rhwng pobl',
      'Creadigol',
      'Datblygu atebion newydd ar gyfer problemau',
      'Yn sylweddoli beth sy’n bwysig i bobl eraill',
      'Yn arbrofi',
      'Yn aml yn rhugl yn y Gymraeg',
      'Gall weld y Llun Mawr',
      'Gall gwneud cysylltiadau rhwng digwyddiadau a gwybodaeth yn gyflym iawn',
      'Yn meddwl mewn trosiadau',
      'Naturiol wrth feddwl creadigol',
      'Yn gydweithredol yn naturiol ac awyddus i weithio dros y lles cyffredin',
      'Sgiliau pobl cryf',
      'Addasol i newid',
      'Da wrth egluro a helpu pobl i ddeall',
      'Da wrth hyrwyddo newid trwy adeiladu perthnasoedd',
      'Idealaidd, agwedd gadarnhaol tuag at fywyd',
    ],
    typeWeakSpots: [
      'Gormwys i wrthdaro',
      'Angen llawer o gadarnhad gan eraill',
      'Weithiau yn dehongli gormod a gall wneud cysylltiadau rhy gyflym rhwng digwyddiadau a gwybodaeth',
      'Awydd am annog a chydnabyddiaeth cyson',
      'Brwdfrydig ar y dechrau ond efallai heb ddilyn drwodd',
      'Gall oedi gwneud penderfyniad i gadw opsiynau ar agor',
      'Cael ei chael yn anodd paratoi ymlaen llaw',
      'Anhawster canolbwyntio ar fanylion',
      'Anallu i oddef trefn',
    ],
    description:
      'Mae’r ENFP yn unigolyn cymdeithasol, ac mae eu brwdfrydedd yn golygu eu bod yn aml yn cwrdd ag eraill. Maent yn debygol o gael eu disgrifio fel y bywyd a’r enaid o’r parti. Mae’r ENFP yn chwilfrydig ac yn annibynnol, yn mwynhau newid a hyblygrwydd, ond yn colli ffocws yn hawdd. Mae gan yr ENFP lawer o “syniadau mawr” ac yn ceisio gweithredu. Maent am gynnwys pawb yn eu syniadau a’u cynlluniau i ychwanegu at y creadigrwydd a’r arloesedd. Maent yn poeni’n ddwfn am eraill a beth mae pobl eraill yn ei feddwl, ac yn gallu disgleirio bywydau’r rhai o’u cwmpas.',
    individualTypeByLetters: 'Ysbryderydd',
    individualDescription:
      'Fel Ysbryderydd, maent yn debygol o fod yn unigolyn cymdeithasol, ac mae eu brwdfrydedd yn golygu eu bod yn aml yn cwrdd ag eraill. Maent yn debygol o gael eu disgrifio fel y bywyd a’r enaid o’r parti. Chwilfrydig ac annibynnol, maent yn tueddu i fwynhau newid a hyblygrwydd, ond gallant golli ffocws yn hawdd. Maent yn debygol o gael llawer o “syniadau mawr” ac yn ceisio gweithredu, gan eisiau cynnwys pawb yn eu syniadau a’u cynlluniau i ychwanegu at y creadigrwydd a’r arloesedd. Maent yn debygol o ofalu’n ddwfn am eraill a beth mae pobl eraill yn ei feddwl, ac yn gallu disgleirio bywydau’r rhai o’u cwmpas.',
  },

  ENTJ: {
    shortDescription: 'Gweithredwr',
    atWorkParagraphs: {
      effectiveness: [
        'Bod yn fwy amyneddgar gyda phobl a allai fod angen mwy o amser i ddeall syniadau cymhleth, abstrakt',
        'Datblygu goddefgarwch uwch tuag at annallu neu aneffeithlonrwydd eraill fel y’u hystyriwyd',
        'Bod yn llai beirniadol ac yn fwy derbyniol tuag at gryfderau a gwendidau eraill',
        'Peidio â gosod safonau annychadwy',
        'Cydnabod anghenion eraill am gefnogaeth emosiynol',
        'Dod o hyd i ffyrdd adeiladol o feirniadu',
        'Datblygu parch iach at fanylion',
        'Ceisio gwrando mwy a dweud llai',
        'Creu mwy o amser ar gyfer myfyrio preifat',
      ],
      teamLeader: [
        'Cymryd rôl cydlynu',
        'Gwella dealltwriaeth a chwblhau tasg trwy ddarparu modelau',
        'Cyfathrebu eu gweledigaeth mewn ffordd sy’n egnioli eraill i gymryd rhan weithredol',
        'Bod yn fwy gwrthrychol i gyfeirio ymdrechion a gweithgareddau eraill tuag at nod cyffredinol',
        'Darparu syniad clir o amcanion cyffredinol',
        'Bod yn agored i feddwl ac felly’n gwerthfawrogi cyfraniadau o unrhyw ffynhonnell',
        'Bod yn ddemocrataidd ac yn annog cyfranogiad',
        'Cymer cyfrifoldeb am eu penderfyniadau',
        'Bod yn hollol ymroddedig i’r dasg',
        'Ysgogi eraill trwy osod safonau uchel',
      ],
      teamLeaderFlipSide: [
        'Weithiau’n cael eu hystyried yn ddi-gystadleuaeth, ddim yn ddigon cadarn neu heb uchelgais.',
        'Weithiau’n cael eu hystyried yn wrthrychol neu wedi’u gwahanu',
        'Heb fynd i’r afael â chasglu gwybodaeth neu archwilio dewisiadau eraill.',
        'Gall ymddangos yn rhy reolaethol',
      ],
      conflicts: [
        'Gallai cael eu poeni gan bobl y maent yn eu hystyried yn annalluog',
        'Gallai cael eu rhwystro gan bobl sy’n dangos diffyg ymroddiad i nodau’r tîm',
        'Mwy tebygol o gael eu rhwystro gan bobl sy’n dangos agwedd anffurfiol ac sy’n ymddangos yn rhy ddiddrefnus.',
        'Mwy tebygol o ddod o hyd i’r gwaith gyda phobl sy’n parhau i drafod mater er bod eglurder eisoes wedi’i gyflawni',
        'Gallai cael eu rhwystro gan bobl sy’n cael eu dal yn trafod manylion y maent yn eu hystyried yn amhriodol i gyfrannu at y nod',
        'Tebygol o wrthdaro gyda phobl nad oes ganddynt agwedd systematig tuag at ddefnyddio amser ac adnoddau',
      ],
      stressAdvisor: [],
      workEnvironment: ['Strwythuredig a threfnus', 'Tueddu i’r dyfodol', 'Yn canolbwyntio ar nodau'],
      underStress: [
        'Gallent ddod yn or-feirniadol tuag atynt eu hunain ac eraill',
        'Gallent fynd yn grac a rheoli heb ystyried effaith eu hymddygiad ar bobl',
      ],
      underSevereStress: ['Gallent deimlo wedi eu dal ac or-emosiynol', 'Gallent glywed sylwadau diniwed fel ymosodiadau personol'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek:
      'Un ffordd y gall %fname wella eu heffeithlonrwydd yn y gwaith yw bod yn llai beirniadol ac yn fwy derbyniol tuag at gryfderau a gwendidau eraill',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      '%fname efallai’n teimlo’n fwy cyfforddus wrth gymryd y rolau canlynol yn eu tîm: Y Trefnydd, Y Generydd Syniadau, Y Beirniad',
    withOthersParagraphs: {
      strengths: [
        'Cymdeithasol ac allanol',
        'Mae rhesymeg a dadansoddiad yn hollbwysig',
        'Beirniadol ac yn cwestiynu’n gyflym',
        'Yn barod i herio eu hunain ac eraill',
        'Assertif, penderfynol',
        'Yn cyfathrebu’n uniongyrchol',
        'Yn hoffi trefnu pobl a chymryd rheolaeth',
        'Dibynadwy ac ymddiriedadwy',
        'Yn gwerthfawrogi cyfiawnder',
      ],
      weakSpotsWithOthers: [
        'Gall pobl llai assertif eu hystyried yn orbwysig, barnus neu ddogmatig',
        'Gall ymddangos fel pe baent yn dal eu hunain mewn rhagor o barch',
        'Gall rhai pobl ddicach eu tuedd i gymryd rheolaeth ar sefyllfaoedd',
        'Gall ymddangos yn oer a dibersonol',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "%fname's type is called ENTJ. Some associated keywords are cynllunydd, gonest, neu frwdfrydig",
    typeKeywords: [
      '1. Cynllunydd',
      '2. Gweledol',
      '3. Trefnydd',
      '4. Rhesymegol',
      '5. Dadansoddol',
      '6. Damcaniaethwr',
      '7. Anhunanol',
      '8. Ymgaisddisgyblaethus',
      '9. Gonestrwydd a gonest',
      '10. Penderfynol',
      '11. Gwrthrychol',
      '12. Brwdfrydig',
    ],
    typePersonalStrengths: [
      'Bod yn ganolbwyntio ar nodau, trefnus ac yn cyflawni canlyniadau fel y rhagwelwyd',
      'Cymer safbwynt tymor hwy wrth ddatrys problemau trwy ganolbwyntio ar syniadau sy’n ymwneud â’r llun mawr',
      'Adnabod gweithdrefnau a pholisïau annresymegol ac aneffeithlon',
      'Dadansoddi a dod â threfn resymegol i broblemau',
      'Datblygu damcaniaethau/modelau/syniadau/systemau newydd i ddatrys problemau',
      'Beirniadu atebion posibl yn wrthrychol',
      'Gweithredu atebion',
      'Dod â egni i dasg',
      'Dysgu pethau newydd, ehangu eu gwybodaeth a’i rannu gyda eraill',
      'Cyflwyno syniadau',
      'Rhoi cyngor arbenigol',
      'Canolbwyntio ar beth allai fod, nid beth ydyw',
      'Cysyniadoli a meddwl yn abstrakt',
      'Gwneud penderfyniadau',
      'Gweithredu gwybodaeth',
    ],
    typeWeakSpots: [
      'Weithiau gall ymddangos yn fwy cadarnhaol a hyderus nag y mae eu profiad yn ei gyfiawnhau',
      'Weithiau gall ymddangos yn orbwysig a rheoli',
      'Weithiau gall bwyso gormod i wneud y gwaith',
      'Gall rhwystro eraill trwy eisiau i’r holl waith gael ei gwblhau ar unwaith',
    ],
    description:
      'Mae’r ENTJ yn unigolyn gonest, penderfynol. Maent yn canolbwyntio ar gyflawni a threfnus, gyda llygaid ar y llun mawr a chynllunio strategol tymor hir. Mae ENTJau yn aml yn hynod deniadol ac yn gallu gwneud i bobl ddilyn eu harweiniad. Maent yn dewis bod yn uniongyrchol ac yn bwrpasol yn eu rhyngweithiadau, gan osgoi mynd yn rhy agos neu bersonol. Mae’r ENTJ yn ymdrechu i fod yn effeithlon ac yn annhebygol o roi’r gorau i dasg, gan ymdrechu i godi dros unrhyw rwystrau sy’n dod yn eu ffordd.',
    individualTypeByLetters: 'Gweithredwr',
    individualDescription:
      'Fel Gweithredwr, maent yn debygol o fod yn unigolyn gonest a phenderfynol. Maent fel arfer yn canolbwyntio’n arbennig ar gyflawni a threfnus, gyda llygaid ar y llun mwy a chynllunio strategol tymor hir. Fel Gweithredwr, maent yn debygol o fod yn deniadol ac yn gallu gwneud i bobl ddilyn eu harweiniad; gan ddewis bod yn uniongyrchol a bwrpasol yn eu rhyngweithiadau, ac osgoi mynd yn rhy agos neu bersonol. Maent yn debygol o ymdrechu i fod yn effeithlon ac yn annhebygol o roi’r gorau i dasg, gan godi dros unrhyw rwystrau yn eu ffordd.',
  },

  ENTP: {
    shortDescription: 'Gweledol',
    atWorkParagraphs: {
      effectiveness: [
        'Cyfrannu eu dyfeisgarwch ond heb orlifo pobl gyda gormod o bosibiliadau',
        'Peidio â lledaenu eu hegni ar draws gormod o brosiectau ar yr un pryd',
        'Datblygu eu hunan-ddisgyblaeth',
        'Defnyddio eu sgiliau dadansoddol i ddod o hyd i’r cyfeiriad maent am ei ddilyn',
        'Gweithio ar eu sgiliau gwneud penderfyniadau',
        'Cofio nad yw gweithredu syniad mor syml â’i ddychmygu',
        'Gweithio ar eu dilyn drwy gadw nodiadau o’r hyn a addawyd ganddynt',
        'Caniatáu i eraill gymryd y llwyfan a disgleirio mwy aml',
        'Peidio â lleihau popeth i fodel cysyniadol',
        'Talu sylw i wybodaeth nad yw’n rhan o faes rhesymegol',
        'Blaenoriaethu posibiliadau amgen, efallai gyda mwy o ffocws ar bobl',
        'Derbyn nad yw’n rhaid iddynt “wybod popeth”',
        'Gwella technegau rheoli amser',
        'Ystyried anghenion rhyngbersonol cydweithwyr yn fwy aml',
        'Canolbwyntio mwy ar ymarferoldeb',
      ],
      teamLeader: [
        'Bod yn weledol, gan greu syniadau newydd yn rhwydd',
        'Ysgogi eraill trwy osod safonau uchel',
        'Disgwyl i eraill herio eu hunain, ac fynd y tu hwnt i’r tasgau a ofynnir',
        'Cynnwys a ysbrydoli’r bobl gorau i weithio gyda nhw',
        'Uno buddiannau aelodau’r tîm mewn cynllun gweithredu',
        'Caniatáu rhyngweithio deinamig rhwng proses a chynnwys',
        'Cwestiynu a beirniadu gwahanol bosibiliadau',
        'Cynnig persbectifau gwahanol yn ogystal â gwybodaeth i ddod o hyd i’r ateb gorau a mwyaf gwrthrychol',
      ],
      conflicts: [
        'Tebygol o gael eu rhwystro gan bobl sy’n gwrthod ystyried posibiliadau newydd',
        'Gallai cael eu poeni gan bobl na all ddeall bod proses a chynnwys yr un mor bwysig',
        'Mwy tebygol o gael eu rhwystro gan bobl na all wahanu’r hanfodol oddi wrth y triviol',
        'Gallai cael gwrthdaro gyda phobl nad oes ganddynt agwedd cyfeiriad cyflawniad a hyder “gall wneud”',
      ],
      stressAdvisor: [
        'Yn cymryd gormod o brosiectau na ellir eu cwblhau',
        'Yn osgoi manylion ac yn dod yn nerfus ac yn cyflym',
        'Yn y pen draw yn tynnu’n ôl o sefyllfa ac yn canfod bod angen llawer o gefnogaeth',
      ],
      workEnvironment: [
        'Yn cynnwys llai o ailadrodd a rhaglen arferol, gyda llawer o gyfleoedd i drafod a chydweithio gyda phobl eraill',
        'Yn cynnwys dychymyg a arloesi lle mae syniadau yn cael eu trafod',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek:
      'Un ffordd y gall %fname wella eu heffeithlonrwydd yn y gwaith yw peidio â gwastraffu eu hegni ar draws gormod o brosiectau ar yr un pryd',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      '%fname efallai’n teimlo’n fwy cyfforddus wrth gymryd y rolau canlynol yn eu tîm: Y Generydd Syniadau, Y Gwneuthurwr neu’r Beirniad',
    withOthersParagraphs: {
      strengths: [
        'Cymdeithasol ac allanol',
        'Cwmni ysgogol, yn wyliadwrus ac yn agored',
        'Yn cwestiynu ac yn barod i herio',
        'Yn rhyddhau egni uchel a hiwmor',
        'Brwdfrydedd heintus',
        'Yn spontan',
        'Cydymdeimladol a chyfeillgar',
        'Gallai ddadleu er mwyn hwyl ar unrhyw ochr i gwestiwn',
        'Yn gwerthfawrogi eraill oherwydd deallusrwydd a gallu a gan nad yw’n dibynnu ar statws',
        'Gall weld persbectifau gwahanol',
        'Da wrth ddarllen pobl eraill',
        'Hyblyg, addasadwy ac agored i feddwl',
        "Hawdd i'w trin ac yn gyfeillgar",
        'Anhunanol, unigol',
      ],
      weakSpotsWithOthers: [
        'Gall ymddangos yn ansensitif i faterion emosiynol weithiau',
        'Gall atal eraill oherwydd eu hoffter o ddadl a brwydro deallusol',
        'Angen uchel am annibyniaeth',
        'Gall orlifo eraill gyda thon o syniadau',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "%fname's Type is called ENTP. Some associated keywords are gweledol, entrepreneuraidd, neu cyflawniad",
    typeKeywords: [
      '1. Rhesymegol',
      '2. Dyfeisgar',
      '3. Meddwl rhydd',
      '4. Brwdfrydig',
      '5. Gweledol',
      '6. Posibiliadau',
      '7. Person y Llun Mawr',
      '8. Entrepreneurial',
      '9. Dychmygus',
      '10. Addasadwy',
      '11. Cymwys',
      '12. Yn canolbwyntio ar gyflawniad',
    ],
    typePersonalStrengths: [
      'Cyflym, rhesymegol, dyfeisgar ac yn dda mewn llawer o bethau',
      'Medr “Os gallant ei ddychmygu, gallant ei wneud”',
      'Yn caru datrys problemau cymhleth ac yn eu hwynebu fel heriau',
      'Arbenigwr mewn canfod patrymau a gweld y llun mawr',
      'Arbenigwr mewn darganfod egwyddorion sylfaenol problem',
      'Da wrth ddatrys problemau gyda thriniaethau tymor hir',
      'Yn dychmygu posibiliadau sefyllfa ac yn eu dadansoddi strategol i benderfynu pa gam gweithredu fydd y mwyaf effeithiol',
      'Yn aml yn medrus mewn sylwi ar dueddiadau a rhagweld y dyfodol',
      'Agwedd uchel tuag at gyflawniad, yn mwynhau herio eu hunain ac eraill',
      'Da wrth ysgogi eraill trwy osod safonau uchel',
      'Gall arbrofi a ymateb i anghenion y foment',
      'Yn cael ei yrru gan ysbrydoliaeth',
      'Cysyniadwr naturiol',
      'Yn tueddu i weithio mewn ton o egni a brwdfrydedd',
      'Gall fod yn weledol deinamig, pensaer y dyfodol',
      'Da wrth arwain ymdrechion newid',
      'Uchder chwilfrydedd deallusol',
      'Da wrth wneud arsylwadau gwrthrychol',
      'Nid yw’n credu mewn rheolau a bydd yn llywio o’u cwmpas i gyflawni eu nod',
      'Annibynnol ac yn hunan-gyfeiriedig',
      'Gall gweithio’n annibynnol',
      'Da wrth gymhwyso gwybodaeth a defnyddio gallu',
      'Arloeswr, cynllunydd a dylunydd, yn mwynhau cymhlethdod',
      'Galluoedd cryf mewn datblygu damcaniaethau, modelau, syniadau neu systemau newydd',
      'Gairwr',
      'Da wrth ddadansoddi pethau gyda rhesymeg a chydymdeimlad',
      'Meddylwr gwreiddiol',
      'Gall dadlau pwynt yn dda',
      'Optimist tragwyddol',
      'Da wrth ffurfio a chlirio syniadau gyda mewnwelediadau creadigol newydd',
      'Da wrth ddarparu dadansoddiad a synthesis',
    ],
    typeWeakSpots: [
      'Anhysbysgar gyda goddefgarwch isel pan mae pethau’n symud yn araf',
      'Yn tueddu i gymryd gormod o bethau ar yr un pryd',
      'Diflasu gan waith arferol ac anfheriol, ac yn brin o wneud yr un peth yr un ffordd',
      'Yn gwerthfawrogi cymwysedd a chyflawniad yn uchel, disgwyl gormod i eraill',
      'Tebygol o osod safonau uchel ar eu hunain a all arwain at amheuon hunan',
    ],
    description:
      'Mae’r ENTP yn arloeswr newid ac yn adnabyddus am eu dyfeisgarwch. Gan ffynnu ar hyblygrwydd ac arloesi, maent yn unigolion cymdeithasol ac yn mwynhau trafod syniadau a chysyniadau, yn aml yn chwarae advocaid y diafol i ysbrydoli pobl eraill i feddwl am ffyrdd newydd ac amrywiol o wneud pethau. Yn egniol ac yn siaradus, mae’r ENTP yn chwilio am amgylcheddau newydd i archwilio i ddod o hyd i heriau deallusol newydd. Nid ydynt yn hoffi unffurfiaeth. Mae ailadrodd yn eu harwain i ledaenu eu hunain yn rhy denau neu wneud pethau’n wahanol i osgoi diflastod a rhoi amrywiaeth a chyffro i dasg.',
    individualTypeByLetters: 'Gweledol',
    individualDescription:
      'Fel Gweledol, maent yn debygol o fod yn arloeswr newid ac yn adnabyddus am eu dyfeisgarwch. Maent yn ffynnu ar hyblygrwydd ac yn ceisio arloesi, maent yn gymdeithasol ac yn mwynhau trafodaethau o syniadau a chysyniadau. Efallai y byddant yn chwarae advocaid y diafol i ysbrydoli pobl eraill i feddwl am ffyrdd newydd ac amrywiol o wneud pethau. Yn egniol ac yn siaradus, maent yn debygol o chwilio am amgylcheddau newydd i archwilio i ddod o hyd i heriau deallusol newydd. Ar ôl ofn unffurfiaeth ac ailadrodd, maent mewn perygl o ledaenu eu hunain yn rhy denau, ac yn ceisio gwneud pethau’n wahanol i osgoi diflastod ac ychwanegu amrywiaeth a chyffro i dasg.',
  },

  ESFJ: {
    shortDescription: 'Darparwr',
    atWorkParagraphs: {
      effectiveness: [
        'Cofio bod yn fwy cryno a mynd yn syth i’r pwynt',
        'Dysgu peidio â chymryd beirniadaeth neu wrthod i’r calon, ond cydnabod y ffeithiau gwrthrychol sydd yn sail iddi',
        'Gweithredu’n llai cyflym ar ran eraill',
        'Gadw i eraill wneud eu camgymeriadau eu hunain',
        'Cofio peidio â thrafod mater i farwolaeth, gan adael i bethau bach fynd yn haws',
        'Lleihau pwyslais ar gytundeb',
        'Cydnabod bod weithiau angen ail-asesu penderfyniadau cytunedig yn sgil gwybodaeth ychwanegol, hyd yn oed os yw hyn yn golygu dechrau drosodd',
        'Cydnabod nad yw cynlluniau a phrosesau wedi eu gosod mewn carreg',
        'Bod yn fwy derbyniol o ragdybiaethau eraill',
        'Cydnabod bod ansicrwydd yn rhan o fywyd ac mae penderfyniadau weithiau’n cael eu gwneud mewn ansicrwydd',
      ],
      teamLeader: [
        'Gosod agenda glir a chyflawni cytundeb a chau trwy barchu’r ymrwymiadau amser',
        'Creu awyrgylch lle mae pawb yn deall eu pwysigrwydd i’r tîm ac yn teimlo’n ysbrydoledig i gyfrannu',
        'Gweithio’n gydweithredol i benderfynu beth sydd angen ei wneud, a phwy sydd fwyaf addas i fynd i’r afael â’r tasgau hyn',
        'Ysgogi eraill drwy ddefnyddio dadleuon perswadiol sy’n ystyried teimladau pobl',
        'Canolbwyntio ar ffyrdd ymarferol i ddod â’r tîm at ei gilydd mewn datrys problemau',
        'Clirio materion agored trwy ofyn y cwestiynau cywir, yn hytrach na rhoi’r holl atebion eu hunain',
      ],
      conflicts: [
        'Gallant wynebu gwrthdaro gyda phobl y maent yn eu gweld fel llonydd',
        'Mwy tebygol o gael gwrthdaro gyda phobl y maent yn eu gweld fel nad ydynt yn cymryd cyfrifoldeb am ddatrys problemau',
        'Gallant gael eu rhwystro gan bobl sy’n gwrthod cadw at yr agenda a gwastraffu amser',
        'Gallant gael eu poeni gan bobl sy’n torri cytundeb trwy chwarae advocaid y diafol',
        'Tebygol o fod â goddefgarwch isel tuag at bobl sy’n arafu cynnydd trwy ymyrryd yn gyson',
        'Mwy tebygol o gael gwrthdaro gyda phobl nad ydynt yn cwblhau tasgau’n gywir ac ar amser',
      ],
      stressAdvisor: [],
      workEnvironment: [],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gallant wella eu heffeithlonrwydd yn y gwaith yw gan ganiatáu i eraill wneud eu camgymeriadau eu hunain',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      'Efallai y teimlant yn fwy cyfforddus wrth gymryd y rolau canlynol yn eu tîm: Y Trefnydd, Y Gwneuthurwr, Y Pwyswrn',
    withOthersParagraphs: {
      strengths: [
        'Calonog, cyfeillgar ac yn gefnogol',
        'Siaradus, poblogaidd',
        'Gofalgar',
        'Cydlynol',
        'Yn tueddu i fod ag ymwybyddiaeth gymdeithasol dda, ac altruistig',
        'Parod, yn barchus',
        'Cymeriad cydymdeimladol sy’n gwneud penderfyniadau ar sail gwerthoedd',
        'Ystyriol',
        'Teimlad cryf o ddyletswydd',
        'Tawel i ffrindiau a chydweithwyr',
        'Gwerthfawrogi traddodiadau',
      ],
      weakSpotsWithOthers: [
        'Yn tueddu i gymryd beirniadaeth wrthrywiol yn bersonol',
        'Yn casáu anghytgord yn ddifrifol, yn osgoi gwrthdaro',
        'Yn arbennig o chwilio am gwerthfawrogiad',
        'Gall fod yn rhy llym, heb addasu’n hawdd i newid',
        'Yn dychmygu camymddwyn lle nad oedd unrhyw fwriad',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "%fname's type is called ESFJ. Some associated keywords are Cydlynol, Cydymdeimladol, neu Trefnus",
    typeKeywords: [
      '1. Cydlyniad',
      '2. Cynnes',
      '3. Trefnus',
      '4. Cydweithredol',
      '5. Gofalgar',
      '6. Manylach',
      '7. Cydymdeimladol',
      '8. Dyletswyddol',
      '9. Ymarferol',
      '10. Systematig ac wedi ei drefnu',
      '11. Cynlluniau',
    ],
    typePersonalStrengths: [
      'Agwedd gadarnhaol ac optimistaidd',
      'Darparu cysur',
      'Da wrth esmwytha gwrthdaro',
      'Tawel i systemau sefydledig ac yn dda wrth gadw traddodiadau',
      'Yn cymryd gwaith o ddifrif ac yn credu y dylai eraill hefyd',
      'Cyfrifol a sylw gwych i fanylion',
      'Yn dod â chylch o gynnes i bopeth a wnânt',
      'Yn debygol iawn o fynd i’r afael hyd yn oed mewn materion bach',
      'Sylwgar, maent yn sylwi ar yr hyn sydd ei angen gan eraill yn eu bywydau bob dydd a cheisio ei ddarparu',
      'Chwaraewr tîm gwych, cydweithredol',
      'Da wrth greu amgylchedd cydlynol',
      'Da wrth drefnu’r byd o’u cwmpas',
      'Gall cyflawni pethau ar amser ac i’r safon ofynnol',
      'Golwg realistig, seiliedig ar ffeithiau',
      'Da wrth ddiffinio dulliau gweithio gyda’i gilydd tuag at nodau',
      'Agwedd gyfrifol tuag at waith, yn gallu dod o hyd i ffordd i fod yn ddefnyddiol',
      'Da wrth gynllunio’n fanwl',
      'Da wrth gynnig persbectif systematig, ymarferol',
      'Da wrth drefnu a ysgogi pobl i gyfrannu',
      'Da wrth fod yn gynhwysol ac yn cydnabod lle mae gan bobl syniadau gwahanol',
      'Da wrth ychwanegu cydlyniad i’r tîm trwy drefniant gofalus, brwdfrydedd a hiwmor',
      'Diddordeb cryf mewn pethau sy’n effeithio’n uniongyrchol ac yn weledol ar fywydau pobl',
      'Agwedd wasanaeth cwsmer cryf, yn hoffi gwneud i bobl deimlo eu bod yn cael eu gwerthfawrogi',
    ],
    typeWeakSpots: [
      'Dymuniad cryf am gydlyniad, yn tueddu i osgoi gwrthdaro lle bo’n bosibl',
      'Yn gweithio’n orau gyda chefnogaeth a phris, ond gall yn dal yn ôl os nad ydynt yn ei dderbyn',
      'Ychydig o ddiddordeb mewn cysyniadau cyffredinol, lle nad yw goblygiadau i bobl go iawn yn uniongyrchol',
      'Angen amgylchedd gwaith trefnus',
      'Yn tueddu i gasáu newid, ansicrwydd a chrisis',
      'Yn cefnogi trefn bresennol ac efallai’n rhy ddibynnol ar awdurdod. Yn cymryd trefn a rheolau sefydledig yn rhy ddifrifol',
      'Yn hiraethu am deimlad o berthyn. Gall ddod yn ddi-bleser a di-ysgog, os nad ydynt yn cael eu gwerthfawrogi am bwy ydyn nhw a beth maent yn ei gyfrannu',
      'Gall orfodi gormod ar statws a hŷn (eu hunain) yn erbyn cymhwysedd (technegol)',
      'Angen rôl tîm a nodau wedi’u diffinio’n glir',
      'Canolbwyntio ar fanylion a all gael ei ddehongli fel diffyg dychymyg gan rai cydweithwyr',
    ],
    description:
      'Mae’r ESFJ yn unigolyn cydymdeimladol, sydd wedi canolbwyntio ar gefnogi eraill a chreu cydlyniad. Mae’r ESFJ yn gyfrifol ac yn ystyried perthnasoedd, gan weld y pethau cadarnhaol mewn pobl. Yn hynod ffyddlon, gyda ymrwymiad i’w tîm, maent yn canolbwyntio ar gyflawni a bod yn barod i roi llaw i helpu eraill allan. Mae’r ESFJ yn hoffi cynnal cydlyniad o fewn y tîm, heb roi lle i bethau fynd ar goll trwy chwilio am atebion sy’n plesio pawb.',
    individualTypeByLetters: 'Darparwr',
    individualDescription:
      'Fel Darparwr, maent yn debygol o fod yn unigolyn cydymdeimladol, sydd wedi canolbwyntio ar gefnogi eraill a chreu cydlyniad. Maent yn debygol o fod yn gyfrifol ac yn ystyried perthnasoedd, gan weld y cadarnhaol mewn pobl. Maent yn tueddu i fod yn hynod ffyddlon, gyda ymrwymiad i’w tîm, gan ganolbwyntio ar gyflawni ac yn barod i roi llaw i helpu eraill allan. Fel Darparwr, maent yn debygol o gynnal cydlyniad o fewn y tîm, heb roi lle i bethau fynd ar goll trwy chwilio am atebion sy’n plesio pawb.',
  },
  ESFP: {
    shortDescription: 'Perfformwr',
    atWorkParagraphs: {
      effectiveness: [
        'Symud i ffwrdd o’u canolbwynt ar y presennol, tuag at dull mwy canolbwyntiedig ar dasgau',
        'Datblygu gwerthfawrogiad gwell o feddwl y “Llun Mawr”',
        'Cael y cydbwysedd cywir rhwng bywiogrwydd a diflinoedd',
        'Mynegi eu barn eu hunain yn fwy penderfynol',
        'Pwysleisio ystyriaethau tasg',
        "Bod yn fwy penderfynol a dweud 'na' i geisiadau anghyfiawn",
        'Canolbwyntio ar ofynion manwl y tasgau',
        'Peidio â chymryd beirniadaeth yn bersonol',
        'Cydnabod gwerth dadansoddiad rhesymegol',
      ],
      teamLeader: [
        'Ceisio dechrau’r holl broses a crynhoi’r penderfyniadau a wnaed',
        'Hyrwyddo cydweithrediad ymhlith aelodau’r tîm a sicrhau bod cryfderau a chyfraniadau pawb yn cael eu gwerthfawrogi',
        'Hyrwyddo cyfranogiad eang a sicrhau bod pob barn a syniad wedi cael ei ystyried cyn gwneud penderfyniad',
        'Hyrwyddo eraill i alluogi canlyniadau cadarnhaol',
      ],
      conflicts: [
        'Gallant gael eu rhwystro gan bobl y maent yn eu gweld fel rhy negyddol, beirniadol, blâmio a phemelus',
        'Gallant gael eu poeni gan bobl sy’n siarad mewn ffordd uchelgeisiol iawn heb wneud pwynt',
        'Gallant gael eu rhwystro gan bobl sy’n canolbwyntio dim ond ar y dasg ac yn ddigynnar i’r bobl o’u cwmpas',
        'Yn tueddu i gael trafferth gweithio gyda phobl sydd â meddwl sengl ac nad ydynt yn gwerthfawrogi safbwyntiau a chyfraniadau gwahanol',
      ],
      stressAdvisor: [],
      workEnvironment: ['Ymarferol', 'Practigol', 'Yn egniol a hwyl', 'Lle mae rhyddid a gofod', 'Heb drefn arferol'],
      underSevereStress: [
        'Gellir eu hystyried yn rhy ymaddasgar, gan bersonoli gormod ac heb roi digon o sylw i fanylion, damcaniaeth neu’r llun mawr.',
      ],
      weakSpotsWithOthers: [
        'O dan straen difrifol gallant gael trafferth tynnu’n ôl o brosiect i fynd i’r anghenion ymarferol neu corfforol',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek:
      'Un ffordd y gallant wella eu heffeithlonrwydd yn y gwaith yw drwy ddatblygu gwerthfawrogiad gwell o feddwl y “Llun Mawr”',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      'Efallai y teimlant yn fwy cyfforddus wrth gymryd y rolau canlynol yn eu tîm: Y Gwneuthurwr, Y Canolwr, neu’r Llinell-Bwmpwr',
    withOthersParagraphs: {
      strengths: [
        'Allanol',
        'Cynnes',
        'Cyfeillgar',
        'Cefnogol',
        'Caru hwyl',
        'Yn anadlu’n rhydd',
        'Cydwybodol',
        'Agored i feddwl',
        'Bywiog',
        'Siaradus',
        'Cydymdeimladol',
        'Tactegol',
        'Cydweithredol',
        'Egalitariaeth',
        'Hawdd i fynd ag ef',
        'Sensitif i anghenion eraill',
      ],
      weakSpotsWithOthers: [
        'Weithiau rhy ymaddasgar',
        'Weithiau rhy emosiynol',
        'Gellir eu hystyried fel rhy anhorganedig',
        'Gall gymryd beirniadaeth yn rhy bersonol',
        'Gall or-dddehongli sefyllfa',
        'Gall geisio gwneud gormod o bethau ar yr un pryd',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "%fname's Type is called ESFP. Some associated keywords are egniol, profiad, neu realistig",
    typeKeywords: [
      '1. Brwdfrydig',
      '2. Optimistaidd',
      '3. Gweithgarwch',
      '4. Egniol',
      '5. Ymarferol',
      '6. Goddefgar',
      '7. Teimladol',
      '8. Realistig',
      '9. Ymrwymol',
      '10. Gweithgareddau newydd, pobl newydd',
      '11. Profiad',
      '12. Addasadwy',
    ],
    typePersonalStrengths: [
      'Lefel uchel o egni',
      'Dod o hyd i atebion ymarferol i broblemau concrid, go iawn',
      'Datblygu atebion sy’n ystyried anghenion a theimladau eraill',
      'Cydymdeimladol ac yn deall pobl, yn barod i ystyried safbwynt eraill',
      'Heb gaethiwo i ddulliau sefydledig hir, ond yn barod i addasu',
      'Targedwyd at nodau, ac yn barod i ddilyn y llwybr uniongyrchol i lwyddiant yn hytrach na gwastraffu amser a llafur diangen',
      'Yn barod ac yn awyddus i wneud pethau’n digwydd',
      'Yn hoffi gweithredu a gwneud pethau’n digwydd',
      'Yn gwybod beth sy’n digwydd ac yn cymryd rhan â brwdfrydedd',
      'Yn dod â synnwyr cyffredin ac agwedd realistig i ddatrys problemau',
      'Da wrth gofio ffeithiau',
      'Da wrth ymateb i argyfyngau',
      'Da wrth esmwytha gwrthdaro',
      'Da wrth fod yn gynhwysol',
      'Yn egniol eraill gyda meddwl cadarnhaol',
    ],
    typeWeakSpots: [
      'Gall fod yn ystyried eu dull yn rhy bersonol',
      'Gall ymddangos fel peidio â thynnu pethau o ddifrif digon',
      'Gall rhwystro eraill drwy wrthod trafodaeth ddamcaniaethol ac egniadol',
      'Tueddiad i osgoi gwrthdaro',
      'Tueddiad i wrthod trefn a chael trafferth dilyn gweithdrefnau a systemau penodol',
      'Yn debygol o beidio â threulio digon o amser yn meistroli damcaniaethau, ond yn hytrach yn mynd yn syth i weithredu',
      'Sylw parhaus i fanylion yw rhywbeth nad yw’n dod yn naturiol iddynt bob amser',
    ],
    description:
      'Mae’r ESFP yn tueddu i fwynhau pethau sy’n plesio’n esthetig. Maent yn debygol o fod yn ymgysylltiol ac optimistaidd, ac yn annog eraill, gan fod yn sensitif iawn i’w hanghenion. Cyfeillgar ac ymarferol, mae cydweithredu a chydlyniad yn bwysig i’r ESFP, gan eu bod yn tueddu i fwynhau gweithgareddau ymarferol ac yn dewis gweithredu a bywiogrwydd i gadw nhw’n ymgysylltiedig ac yn diddordeb. Gan ddod â gobaith ac optimistiaeth, ac agwedd “gall-wneud”, mae’r ESFP yn debygol o ddod â awyrgylch cydweithredol a phersonol i sefyllfa, ynghyd â phwrpas a gweithredu.',
    individualTypeByLetters: 'Perfformwr',
    individualDescription:
      'Fel Perfformwr, maent yn tueddu i fwynhau pethau sy’n plesio’n esthetig. Maent yn debygol o fod yn ymgysylltiol ac optimistaidd, ac yn annog eraill, gan fod yn sensitif iawn i’w hanghenion. Fel cyfeillgar ac ymarferol, mae cydweithredu a chydlyniad yn bwysig iddynt gan eu bod yn tueddu i fwynhau gweithgareddau ymarferol ac yn dewis gweithredu a bywiogrwydd i gadw nhw’n ymgysylltiedig ac yn diddordeb. Gan ddod â gobaith ac optimistiaeth, ac agwedd “gall-wneud”, maent yn debygol o ddod â awyrgylch cydweithredol a phersonol i sefyllfa, ynghyd â phwrpas a gweithredu.',
  },
  ESTJ: {
    shortDescription: 'Gwarchodwr',
    atWorkParagraphs: {
      effectiveness: [
        'Dod yn fwy sensitif i anghenion pobl',
        'Edrych y tu hwnt i ffeithiau tuag at y llun mawr',
        'Gwrando mwy ar eraill a rhoi pwysau mwy ar safbwyntiau gwrthwynebol',
        'Sicrhau eu bod wedi casglu digon o wybodaeth cyn ymdrechu i gwblhau tasgau',
        'Dirprwyo mwy a gadael i eraill ddatblygu eu sgiliau arweinyddiaeth',
        'Deall bod y broses yn allweddol i ddarparu cynnyrch da a dysgu sut i symud yn gyflymach na cham ar y tro',
        'Bod yn fwy agored i safbwyntiau amgen hyd yn oed os nad ydynt yn gwneud llawer o synnwyr ar y dechrau',
        'Pwysleisio ystyriaethau personol yn ogystal â thasgau',
        'Gadael digon o le i eraill fod yn arloesol a hyrwyddo creadigrwydd',
        'Datblygu eu synnwyr tact a diplomyddiaeth',
        'Bod yn fwy agored i arbrofi',
        'Drosglwyddo barn feirniadol wrth feddwl creadigol',
        'Cynyddu eu goddefgarwch o ansicrwydd',
      ],
      teamLeader: [
        'Bod yn dda wrth roi cyfarwyddyd',
        'Bod yn bwrpasol wrth weithredu cynlluniau',
        'Bod yn dda wrth reoli ymddygiad gyda pholisïau caeth',
        'Datblygu cynlluniau manwl, canolbwyntiedig ar ganlyniadau',
        'Bod yn dda wrth diffinio a egluro materion',
        'Rhoi tasg a chyfrifoldeb clir i bob aelod o’r tîm',
        'Herio eu tîm yn barhaus i wneud eu gorau',
        'Bod yn dda wrth sicrhau bod pobl yn cadw at reolau a pholisïau',
        'Dangos egni a ymrwymiad uchel',
        'Bod yn dda wrth sicrhau bod pethau’n cael eu cyflawni',
      ],
      conflicts: [
        'Yn fwy tebygol o gael eu rhwystro gan aelodau tîm nad ydynt yn canolbwyntio, yn straying o’r dasg ac yn gwastraffu amser',
        'Gallant gael eu rhwystro gan aelodau tîm nad ydynt wedi paratoi ac nad ydynt yn dilyn tasgau',
        'Yn fwy tebygol o gael eu rhwystro gan gyfarfodydd nad ydynt yn cael eu hystyried yn glir o ran nodau, agenda neu drefn',
        'Gallant fod yn anhapus wrth weithio mewn rôl sydd heb ddiffiniad a nodau clir',
        'Gallant wrthdaro gyda chyd-aelodau tîm sy’n aml yn hwyr, absenol neu’n bresennol ond heb gymryd rhan',
      ],
      underStress: [
        'O dan straen: Gallant ddod yn orfeirniadol o’u hunain ac eraill.',
        'Gallant deimlo nad ydynt yn cael eu gwerthfawrogi neu glywed sylwadau diniwed fel ymosodiadau personol.',
        'O dan straen mawr: Gall ESTJ hefyd ddod yn ddig ac yn reoli, gan roi cyfarwyddiadau heb feddwl am ganlyniadau i eraill',
      ],
      stressAdvisor: [
        'O dan straen: Gallant ddod yn orfeirniadol o’u hunain ac eraill.',
        'Gallant deimlo nad ydynt yn cael eu gwerthfawrogi neu glywed sylwadau diniwed fel ymosodiadau personol.',
        'O dan straen mawr: Gall ESTJ hefyd ddod yn ddig ac yn reoli, gan roi cyfarwyddiadau heb feddwl am ganlyniadau i eraill.',
      ],
      workEnvironment: [
        'Caniatáu canolbwyntio ar fanylion a chynlluniau, lle mae cyfrifoldebau wedi’u diffinio’n glir',
        'Lle mae pobl yn aml o gwmpas, gyda chyfleoedd i gymryd yr awenau',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek:
      'Un ffordd y gallant wella eu heffeithlonrwydd yn y gwaith yw drwy ddod yn fwy sensitif i anghenion rhyngbersonol pobl.',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      '%fname efallai y teimla’n fwy cyfforddus wrth gymryd y rolau canlynol yn eu tîm: Y Gwneuthurwr, Y Trefnydd, neu’r Prynwr',
    withOthersParagraphs: {
      strengths: [
        'Cymdeithasol, bywiog ac allanol',
        'Hyderus ac yn hunan-ymddiriedol',
        'Yn mynegi eu barn eu hunain yn gyflym',
        'Siaradus, uniongyrchol, heb ddirgelwch',
        'Cyfrifol ac atebol',
        'Yn gwerthfawrogi effeithlonrwydd ac effeithiolrwydd eraill',
        'Yn feirniadol yn agored i eraill nad ydynt yn cwrdd â’u safonau personol',
        'Yn barod i oruchwylio eraill i weld trefn ymarferol naturiol yn cael ei gweithredu',
        'Yn weithgar wrth wneud cysylltiadau cymdeithasol newydd',
        'Caled eu meddwl',
        'Yn gyfforddus wrth roi cyfarwyddiadau',
      ],
      weakSpotsWithOthers: [
        'Deall teimladau eraill efallai nad yw’n naturiol',
        'Gellir eu hystyried fel rhy uniongyrchol',
        'Gall ymddangos fel rhy reoliadol. Tendrwydd i wneud penderfyniadau ar ran eraill heb gael eu cydsyniad',
        'Dymuniad cryf i fod yn sicr gall wneud hi’n anodd derbyn safbwyntiau ac arsylwadau sy’n gwrthwynebu eu hunain',
        'Gellir ystyried yn awtocrataidd',
        'Tendrwydd i wneud penderfyniadau yn rhy gyflym heb gasglu digon o wybodaeth',
        'Gall ymddangos fel peidio â meddwl am ganlyniadau',
        'Gall ymddangos yn anghydnaws',
        'Gall golli’r ffactor dynol wrth gyflawni tasgau',
        'Gellir ei ystyried fel orfeirniadol ac yn amyneddgar',
        'Efallai nad yw’n gynhwysol digon',
        'Canolbwyntio ar fanylion a gweithdrefnau efallai ystyrir fel diffyg dychymyg',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "%fname's type is called ESTJ. Some associated keywords are penderfynol, rhesymegol, neu reolwr",
    typeKeywords: [
      '1. Penderfynol',
      '2. Caled eu meddwl',
      '3. Trefnus',
      '4. Manwl gywir',
      '5. Cyfrifol',
      '6. Gweithdrefnau',
      '7. Rhesymegol',
      '8. Rheolwr',
      '9. Trefnus',
      '10. Seiliedig ar ffeithiau',
      '11. Dadansoddol',
      '12. Egwyddorol',
    ],
    typePersonalStrengths: [
      'Da wrth ddadansoddi a dod â threfn i’r byd',
      'Da wrth drefnu prosiectau a phobl',
      'Conscientious ac yn gweithio’n egniol i gwblhau tasgau',
      'Canolbwynt cryf ar gael canlyniadau gweledol a phrydlon yn y ffordd fwyaf effeithlon',
      'Ymagwedd ymarferol, realistig a gweithgar',
      'Yn delio â phroblemau ac eraill mewn ffordd uniongyrchol, heb ddirgelwch',
      'Meddwl rhesymegol cryf',
      'Ethos gwaith cryf',
      'Da wrth ofalu am fanylion arferol',
      'Cryf wrth gynllunio',
      'Penderfynol a chyflym wrth weithredu penderfyniadau',
      'Da wrth ddogfennu gweithdrefnau a gwybodaeth',
      'Sylw gwych i fanylion ac yn dda wrth ddal a chywiro camgymeriadau',
      'Da wrth wella pethau trwy gamau bach',
      'Hoff o gymryd yr awenau',
      'Da wrth gadw traddodiadau, yn loyol i’r system a strwythurau presennol',
      'Dibynadwy, yn cymryd cyfrifoldebau’n ddifrifol',
      'Da wrth gasglu pethau',
      'Da wrth aflonyddu ar reolau a pholisïau',
      'Safbwynt realistig, gyda chanolbwynt clir ar beth sydd angen ei wneud nesaf',
      'Yn aml yn dilyn set glir o safonau rhesymegol yn systematig',
      'Da wrth annog gofal',
      'Ymagwedd systematig a methodaidd',
    ],
    typeWeakSpots: [
      'Goddefgarwch isel o ansicrwydd, yn well ganddynt fod yn sicr o’u crediadau a bod yn anghywir na delio ag ansicrwydd',
      'Yn amharod i newid strwythurau a thraddodiadau presennol. Efallai’n gwerthfawrogi sefydlogrwydd dros arloesedd',
      'Efallai’n canolbwyntio gormod ar yr union bresennol a anghofio canlyniadau tymor hir',
      'Anghydnaws i newidiadau cynllun',
      'Canolbwynt cryf ar fanylion efallai’n cyfyngu ar allu i feddwl y llun mawr',
      'Efallai’n atal eu creadigrwydd eu hunain a eraill trwy ddisbyddu syniadau nad ydynt o ddefnydd uniongyrchol',
      'Efallai’n gorwerthfawrogi pwysigrwydd hierarchaeth, pŵer ffurfiol ac awdurdod',
      'Efallai’n anghofio ystyried teimladau a safbwyntiau eraill wrth wneud penderfyniadau',
      'Weithiau gormod o ofalus',
    ],
    description:
      'Mae’r ESTJ yn debygol o fod yn egniol ac yn canolbwyntio ar gyflawni. Er nad ydynt yn hyblyg yn naturiol, maent yn tueddu i hoffi cynllunio a phwrpas, ac yn aml yn hapus i gymryd rheolaeth ar sefyllfa. Fel Gwarchodwr, maent yn tueddu i ddibynnu ar ffyrdd profedig, gan weithio gyda gwybodaeth ffeithiol a gweithdrefnau systematig. Fel person allanol, maent yn debygol o fod yn hapus i fod yn ganolbwynt sylw, yn dadlau eu syniadau a’u cysyniadau. Wrth weithio gyda chyfarwyddyd a chynllun i anelu ato, maent yn gallu creu trefn allan o anhrefn.',
    individualTypeByLetters: 'Gwarchodwr',
    individualDescription:
      'Fel Gwarchodwr, maent yn debygol o fod yn egniol ac yn canolbwyntio ar gyflawni. Er nad ydynt yn hyblyg yn naturiol, maent yn tueddu i hoffi cynllunio a phwrpas, ac yn aml yn hapus i gymryd rheolaeth ar sefyllfa. Fel Gwarchodwr, maent yn tueddu i ddibynnu ar ffyrdd profedig, gan weithio gyda gwybodaeth ffeithiol a gweithdrefnau systematig. Fel person allanol, maent yn debygol o fod yn hapus i fod yn ganolbwynt sylw, yn dadlau eu syniadau a’u cysyniadau. Wrth weithio gyda chyfarwyddyd a chynllun i anelu ato, maent yn debygol o allu creu trefn allan o anhrefn.',
  },
  ESTP: {
    shortDescription: 'Gweithredwr',
    atWorkParagraphs: {
      effectiveness: [
        'Adeiladu ar eu cryfder wrth gyflwyno ffeithiau a chael golwg realistig',
        'Dibynnu llai ar arbrofi (er eu bod yn dda iawn arno) a mwy ar baratoi',
        'Cymryd mwy o amser cyn gweithredu',
        'Defnyddio eu synnwyr digrifwch da, ond bod yn ymwybodol o’r effaith negyddol y gall sylwadau sarhaus gael ar eraill',
        'Ceisio osgoi argyfwng, er eu bod yn dyheu’n gyfrinachol am yr egni a ddaw gyda hyn',
        'Bod yn barod i gymodi pan fo’n briodol i symud y tîm ymlaen',
        'Ymarfer eu sgiliau gwrando',
        'Derbyn ac annog arloesedd mewn eraill',
        'Gwrando mwy ar anghenion rhyngbersonol cydweithwyr',
      ],
      teamLeader: [
        'Rhoi cyfeiriad a phwrpas clir i’w tîm',
        'Mynegi’r broblem, casglu safbwyntiau, trafod dewisiadau ac wneud penderfyniad ymarferol sy’n gweithio',
        'Gwneud i’w tîm weithio gyda’i gilydd yn y ffordd fwyaf effeithlon',
        'Ysgogi eu pobl i weithredu',
        'Addasu’n gyflym i newidiadau yn yr amgylchedd a chryfhau neu newid eu strategaeth',
        'Peidio â barnu syniadau eraill cyhyd â’u bod yn rhesymegol',
      ],
      conflicts: [
        'Gall fod yn rhwystredig gan aelodau tîm y maent yn eu hystyried yn basif ac heb ymrwymiad',
        'Gall fod â goddefgarwch isel i bobl y maent yn eu hystyried heb ganolbwynt a heb realiti',
        'Yn fwy tebygol o gael problemau gyda chyd-aelodau tîm nad ydynt yn gweld y llwybr rhesymegol ac yn cael eu tynnu’n ôl gan nodau eilaidd heb wobr uniongyrchol',
        'Yn fwy tebygol o fod yn rhwystredig gan bobl sy’n cwyno, yn pwyso’n feirniadol ac yn negyddol gormod',
        'Gall fod yn rhwystredig gan bobl heb synnwyr digrifwch',
      ],
      stressAdvisor: [
        'Yn gwrthsefyll rheolau ac yn dod yn gystadleuol',
        'Yn cymryd gormod o brosiectau ac yn dod yn rhai arbrofol ac efallai’n beryglus',
        'Meddu’n ofalus cyn siarad, neu gall ymddangos yn uniongyrchol a didostur',
      ],
      workEnvironment: ['Hoff o gyfleoedd i fod yn hyblyg ac i greu syniadau', 'Yn casáu cael eu cyfyngu gan ormod o reolau a rheoliadau'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gall %fname wella eu heffeithlonrwydd yn y gwaith yw symud i weithredu yn fwy ysgafn',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      '%fname efallai y teimla’n fwy cyfforddus wrth gymryd y rolau canlynol yn eu tîm: Y Spanwr Ffiniau, Y Gwneuthurwr, neu’r Cyfryngwr',
    withOthersParagraphs: {
      strengths: [
        'Cymdeithasol ac agored',
        'Arbrofol ac egniol',
        'Agored i feddwl ac yn goddefgar',
        'Synnwyr digrifwch da',
        'Yn cael ei werthfawrogi am realiti syml',
        'Egniol',
        'Anturus ac yn hoff o hwyl',
        'Yn hyderus',
      ],
      weakSpotsWithOthers: [
        'Gall niweidio eraill heb fwriad drwy fynegi barn yn uniongyrchol',
        'Yn aml yn rhy awyddus i ddisbyddu systemau sy’n rhoi sefydlogrwydd i eraill',
        'Gall fod yn amyneddgar gyda dimensiynau rhyngbersonol tasg',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "%fname's type is called ESTP. Some associated keywords are rhesymegol, canolbwyntio ar ffeithiau, neu addasadwy",
    typeKeywords: [
      '1. Arbrofol',
      '2. Agored i feddwl',
      '3. Gweithredu',
      '4. Rhesymegol',
      '5. Ymarferol',
      '6. Arbrofiwr',
      '7. Datrys problemau',
      '8. Anturus',
      '9. Egniol',
      '10. Digri',
      '11. Addasadwy',
      '12. Seiliedig ar ffeithiau',
    ],
    typePersonalStrengths: [
      'Da wrth ddatrys problemau ymarferol ar y fan a’r lle',
      'Datrys problemau naturiol ac yn dda wrth symud rhwystrau neu ddatrys anawsterau',
      'Agwedd bositif ac ymroddiad egniol i lwyddo',
      'Da mewn sefyllfaoedd argyfyngus',
      'Addasadwy, goddefgar a hyblyg',
      'Yn gryf yn gweithredu ac yn dda wrth ysgogi eraill i weithredu',
      'Realistig a syml',
      'Da wrth ddadansoddi gwneud penderfyniadau rhesymegol',
      'Da gyda pethau ymarferol y gellir eu trin, torri i fyny neu eu cydosod',
      'Yn ffurfio perthnasoedd newydd yn gyflym',
      'Barod i osgoi systemau a protocolau sefydledig i ddod o hyd i atebion',
    ],
    typeWeakSpots: [
      'Yn tueddu i beidio â hoffi esboniadau hir a damcaniaethol',
      'Yn cael diflastod gan ormod o sefydlogrwydd',
      'Yn tueddu i weithredu gormod o gyflym',
      'Yn anwybyddu manylion manwl tasg',
      'Yn hoffi dysgu drwy brofiad ymarferol yn hytrach nag astudio neu adlewyrchu preifat',
    ],
    description:
      'Mae’r ESTP yn debygol o fod â chariad cryf at weithredu, ac yn mwynhau amgylchedd cyflym. Maent yn debygol o fod yn unigolyn egniol, sy’n ymddangos yn swynol ac yn uniongyrchol. Mae’r ESTP yn tueddu i ganolbwyntio mwy ar weithgareddau ymarferol a chynllunio, er eu bod yn mwynhau amrywiaeth, heriau a hyblygrwydd, maent yn ei chael yn anodd delio â thasgau diflas a rhyfeddol. Fel Gweithredwr, mae angen iddynt fod yn wyliadwrus rhag ceisio gwneud gormod o bethau ar yr un pryd ac yn cymryd gormod o risgiau gan y gall hynny greu anhrefn. Maent yn tueddu i roi rhesymegoldeb a meddwl cyn teimladau eraill, gan ffafrio delio â manylion penodol ac ymarferol.',
    individualTypeByLetters: 'Gweithredwr',
    individualDescription:
      'Fel Gweithredwr, maent yn debygol o fod â chariad cryf at weithredu ac yn mwynhau amgylchedd cyflym. Maent yn unigolyn egniol sy’n ymddangos yn swynol ac yn uniongyrchol. Maent yn tueddu i ganolbwyntio mwy ar weithgareddau ymarferol a chynllunio, gan fwynhau amrywiaeth, heriau a hyblygrwydd, ond yn ei chael yn anodd delio â thasgau diflas a rhyfeddol. Fel Gweithredwr, mae angen iddynt fod yn wyliadwrus rhag ceisio gwneud gormod o bethau ar yr un pryd ac yn cymryd gormod o risgiau gan y gall hynny greu anhrefn. Maent yn tueddu i roi rhesymegoldeb a meddwl cyn deimladau eraill, gan ffafrio delio â manylion penodol ac ymarferol.',
  },
  INFJ: {
    shortDescription: 'Amddiffynnwr',
    atWorkParagraphs: {
      effectiveness: [
        'Mynegi eu meddyliau, teimladau a gwerthoedd personol yn fwy rhydd',
        'Peidio â glynu gormod at un syniad',
        'Datblygu sgiliau rhwydweithio a gwneud cyfeillgarwch achlysurol',
        'Cydnabod pwysigrwydd sgyrsiau bach',
        'Gwneud yn siŵr nad ydynt yn anwybyddu’r presennol oherwydd eu bod yn canolbwyntio gormod ar bosibiliadau’r dyfodol',
        'Dysgu sut i werthu eu hunain yn well',
        'Ymarfer technegau cadarnhaol',
        'Atgoffa eu hunain bod pobl yn fwy tebygol o weithredu ar syniad pan fyddant wedi cael cyfle i gyfrannu',
        'Cydnabod bod yn bwysig peidio â thynnu’n ôl oddi wrth bobl mewn amseroedd o straen',
        'Peidio â gosod safonau anhygyrch ar eich hun a phobl eraill',
      ],
      teamLeader: [
        'Yn gweld y darlun mawr ac yn datblygu gweledigaeth',
        'Yn delio â aelodau’r tîm yn unigol ac yn disgwyl i bob aelod gyflawni’r tasgau a neilltuwyd',
        'Yn ysgogi’r tîm gyda mewnwelediadau creadigol ac intuitif',
        'Yn cymodi â’r mwyafrif, oni bai bod gwrthdaro gyda’u gwerthoedd personol',
        'Yn llwyddo i reoli’r dramatig rhyngbersonol o fewn grwpiau',
        'Yn asesu dinameg y grŵp ac yn darparu trosolwg a crynodebau manwl ar sut i symud ymlaen',
        'Yn dod â gorffen i gyfarfodydd',
      ],
      conflicts: [
        'Yn debygol o fod yn rhwystredig gan bobl a ystyrir yn wrthwynebus, anufudd, neu bersonolneg, neu gan bobl nad ydynt yn gwerthfawrogi eraill',
        'Yn debygol o gael problemau gyda phobl sy’n rhoi cyngor rhy fuan neu amhriodol, ac nad ydynt yn barod i edrych ar faterion yn fanwl',
        'Gall fod yn rhwystredig gan bobl sy’n swnllyd iawn',
        'Gall fod yn rhwystredig gan bobl nad ydynt yn cyfrannu at y gwaith dan sylw',
        'Yn debygol o wrthdaro â phobl sy’n canolbwyntio’n unig ar gynnwys, ac nad ydynt yn talu sylw i’r broses',
      ],
      stressAdvisor: [
        'Gall ddod yn or-bydymol, gan deimlo’r angen i plesio ar bob cyfle',
        'Yn cael trafferth delio â beirniadaeth',
        'Yn teimlo’r angen i ddatrys problemau ar eu pennau eu hunain',
      ],
      workEnvironment: [
        'Lle mae cyfleoedd i weithio ar y darlun mawr, bod yn greadigol, gyda’r posibilrwydd i fod yn hyblyg',
        'Lle mae llai o dasgau ac amserlenni rheolaidd',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gallwch wella eich effeithlonrwydd yn y gwaith yw peidio â glynu gormod at syniadau',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      '%fname efallai y teimla’n fwy cyfforddus wrth gymryd y rolau canlynol mewn tîm: Y Precisian, Y Gynhyrchydd Syniadau, Y Cyfryngwr',
    withOthersParagraphs: {
      strengths: [
        'Tawel, cyfeillgar ac yn gymdeithasol',
        'Yn gwerthfawrogi pobl a pherthnasoedd yn gryf',
        'Cydymdeimladol',
        'Yn dawel ond yn benderfynol',
        'Yn ddwfn yn emosiynol',
        'Yn annhebygol o agor i bobl tan eu bod yn eu hadnabod yn dda',
        'Yn sensitif i anghenion eraill',
        'Yn mwynhau cytgord rhwng pobl',
        'Yn ofalgar ac ystyriol',
        'Egwyddorion cadarn',
      ],
      weakSpotsWithOthers: [
        'Hyper-sensitif i wrthdaro',
        'Angen annogaeth a chydnabyddiaeth',
        'Angen amser ar gyfer ymddiriedolaeth rhyngbersonol',
        'Gall weld beirniadaeth pan nad oedd un wedi ei fwriadu',
        'Gall fod yn rhy ofalus ac yn methu gweithredu’n arbrofol',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "%fname's type is called INFJ. Some associated keywords are parhaus, gofalgar, cyfeillgar",
    typeKeywords: [
      '1. Egwyddorol',
      '2. Creadigol',
      '3. Meddwlgar',
      '4. Trefnus',
      '5. Parhaus',
      '6. Cyfrifol',
      '7. Cydymdeimladol',
      '8. Cyfeillgar',
      '9. Gofalgar',
      '10. Cyfrifol',
      '11. Cytgordol',
    ],
    typePersonalStrengths: [
      'Da wrth edrych ar broblemau o bersbectif byd-eang',
      'Da wrth roi hygrededd trwy syniadau ac mewnwelediadau',
      'Da wrth ysbrydoli eraill trwy agwedd bositif, hiwmor, a gallu gwneud',
      'Da wrth feddwl cysyniadol ac abstrakt',
      'Yn aml yn dda wrth fynegi creadigol',
      'Agwedd gyfrifol i’r gwaith',
      'Trefnus ac yn ddullus',
      'Yn rhoi sylw cryf i fanylion',
      'Yn rhoi eu gorau i’w gwaith',
      'Yn parhau i geisio llwyddo',
      'Da wrth gosod nodau',
      'Yn cyflawni tasgau a bydd yn gwneud unrhyw beth sydd ei angen neu ei eisiau',
      'Yn benderfynol wrth weithredu eu gweledigaeth',
      'Diddordeb cryf i wasanaethu lles cyffredinol',
      'Da wrth hyrwyddo newid drwy berthnasoedd',
      'Da wrth ddysgu a helpu pobl i ddeall',
      'Synnwyr cryf o ddyletswydd a chyfrifoldeb',
      'Yn sylweddoli pwysigrwydd cadw at y rheolau',
      'Yn cwblhau tasgau ar amser ac i safon uchel',
      'Da wrth ddeall egwyddorion damcaniaethol sy’n sail i broblemau',
    ],
    typeWeakSpots: [
      'Bod yn fwy agored mewn sefyllfaoedd cymdeithasol',
      'Bod yn fwy dewisol ynghylch pa raddau y mae penderfyniadau angen eu meddwl yn fanwl cyn gweithredu',
      'Bod yn llai ofni gwrthdaro a llai canolbwyntio ar gytgord',
      'Bod yn fwy cyfforddus wrth gyfathrebu â grwpiau mawr',
      'Cynnwys anghyfforddusder gwneud penderfyniadau anodd, anhoblogaidd',
    ],
    description:
      'Mae’r INFJ yn rhoi pwysigrwydd ar drugaredd a chydweithrediad, gan dueddu i fod yn ddatryswyr problemau da oherwydd eu harloesedd a’u hangerdd i gadw pethau wedi’u trefnu a’u cwblhau. Fel math mewnol, mae’r INFJ yn dueddol o fod yn sensitif ac yn wrthrychol, ac yn debygol o gadw eu teimladau i’w hunain. Fodd bynnag, maent yn dangos llawer o drugaredd tuag at les pobl eraill, ac yn debygol o fod â natur ofalus iawn. Gyda’u hangerdd i gadw pethau wedi’u trefnu, mae hyn yn golygu eu bod yn gallu cwblhau tasgau heb golli eu dull personol a thyner. Mae gallu teimlo eu bod yn gwella pethau yn hynod bwysig i’r INFJ.',
    individualTypeByLetters: 'Amddiffynnwr',
    individualDescription:
      'Fel Amddiffynnwr, mae %fname yn rhoi pwysigrwydd ar drugaredd a chydweithrediad. Mae %fname yn debygol o fod yn ddatryswyr problemau da, oherwydd eu harloesedd a’u hangerdd i gadw pethau wedi’u trefnu a chael pethau’n gyflawn. Fel math mewnol, mae %fname yn dueddol o fod yn sensitif ac yn wrthrychol, ac yn tueddu i gadw eu teimladau i’w hunain. Fodd bynnag, mae %fname yn dangos llawer o drugaredd tuag at les pobl eraill, ac yn debygol o fod â natur ofalus iawn. Gyda’u hangerdd i gadw pethau wedi’u trefnu, maent yn debygol o allu cwblhau tasgau heb golli eu dull personol a thyner. Mae gallu teimlo eu bod yn gwella pethau yn hynod bwysig i %fname.',
  },
  INFP: {
    shortDescription: 'Idealydd',
    atWorkParagraphs: {
      effectiveness: [
        'Dysgu a ymarfer sut i fod yn gadarnhaol',
        'Peidio â thynnu’n ôl oddi wrth bobl pan fydd pethau’n peri straen',
        'Gwella eu sgiliau rheoli amser a blaenoriaethu',
        'Sylweddoli y gall eraill werthfawrogi canlyniadau cyflym, hyd yn oed os nad ydynt yn berffaith eto',
        'Datblygu parch iach at fanylion a phrydlondeb',
        'Cydnabod gwerth cyfeillgarwch achlysurol a rhwydweithio',
        'Peidio â chymhlethu problemau gormod na’u tros-intellectuol',
        'Sylweddoli nad oes rhaid plesio pawb',
        'Cynllunio ymlaen llaw',
        'Dangos mwy o benderfyniad',
        'Ysbrydoli eraill gyda’u syniadau am y posibilrwydd o’r Darlun Mawr',
      ],
      teamLeader: [
        'Darparu cymhelliant ysbrydoledig',
        'Canolbwyntio ar egwyddorion cyffredin a materion sylfaenol',
        'Hyrwyddo ysbryd tîm a gwaith grŵp drwy greu awyrgylch cadarnhaol',
        'Chwilio am gytgord y grŵp i hwyluso nodau',
        'Yn ymwybodol iawn o gryfderau a gwendidau pobl',
        'Gwyntio pobl i gyrraedd eu potensial',
        'Herio a ysgogi pobl',
        'Anog eu timau i edrych ar bosibiliadau newydd',
        'Cadw lefel uchel o morâl a dealltwriaeth dda o gydweithrediad oherwydd eu gallu i "ddarllen" pobl',
      ],
      conflicts: [
        'Gallai gael problemau gyda phobl sy’n cymryd eu hunain yn orfawr o ddifrif',
        'Gall fod yn rhwystredig gan bobl sy’n gofyn am ormod o fanylion neu lle mae rhesymeg dechnegol yn rhwystro dealltwriaeth',
        'Gall fod yn rhwystredig gan bobl nad ydynt yn cydnabod pan nad ydynt yn deall syniad',
        'Gall fod yn rhwystredig gan bobl nad ydynt yn ystyried pob barn',
      ],
      stressAdvisor: [
        'Yn datblygu angen cynyddol am berffeithrwydd',
        'Yn dod yn gul i weld dim ond yr hyn maent yn ei ystyried yn bwysig',
        'Yn colli realaeth a symlrwydd wrth gwblhau tasg',
      ],
      workEnvironment: ['Yn edrych i’r dyfodol', 'Yn adlewyrchu eu gwerthoedd eu hunain', 'Yn caniatáu gweithio mewn byrfeydd egni'],
      underStress: [],
      underSevereStress: [],
    },
    atWorkTagLine: 'Llafur cydweithredol iawn',
    atWorkSneakPeek: 'Un ffordd y gallant wella eu heffeithlonrwydd yn y gwaith yw dysgu a ymarfer sut i fod yn gadarnhaol',
    withOthersTagLine: '',
    withOthersSneakPeek: '',
    withOthersParagraphs: {
      strengths: [
        'Cyfeillgar',
        'Tolerant',
        'Cydweithredol',
        'Cefnogol',
        'Cydymdeimladol',
        'Dirgel',
        'Rhoi adborth positif yn hael',
        'Ystyriol, meddwlgar ac ofalus',
        'Yn ffyddlon iawn i’r bobl y maent yn gofalu amdanynt',
        'Derbyniol',
        'Gofal gwirioneddol',
      ],
      weakSpotsWithOthers: [
        'Angen eu cyfran deg eu hunain o annogaeth a chydnabyddiaeth',
        'Yn hoffi i berthnasoedd fod yn gytgordol ac yn casáu gwrthdaro',
        'Pan fyddant yn rhy brysur â’r hyn maent yn ei wneud, maent yn dod yn anghymdeithasol',
        'Yn tueddu cymryd gormod ar unwaith',
        'Yn tueddu peidio â delio’n dda â phobl sy’n bygwth eu gwerthoedd personol',
        'Gormod o sensitifrwydd i deimladau eraill a hwyl tîm',
      ],
    },
    typeTagLine: 'agored i feddwl, rhyddfeddwl, chwilfrydig yn emosiynol',
    typeSneakPeek: 'Eu math o berson yw INFP. Maent yn tueddu peidio â delio’n dda â phobl sy’n bygwth eu gwerthoedd personol',
    typeKeywords: [
      '1. Agored i feddwl',
      '2. Rhyddfeddwl',
      '3. Chwilfrydig yn emosiynol',
      '4. Eiddgar i ddysgu',
      '5. Dychmygus',
      '6. Optimistaidd',
      '7. Gyrru gan werthoedd',
      '8. Datblygu personol',
      '9. Archwilydd',
      '10. Cefnogol',
      '11. Meddwlgar',
      '12. “Darlun Mawr”',
    ],
    typePersonalStrengths: [
      'Yn llawn brwdfrydedd',
      'Hyblyg ac addasadwy',
      'Arddull gweithio annibynnol',
      'Cyfrifol',
      'Llafur cydweithredol iawn',
      'Ysbryd tîm cryf',
      'Yn barod i gyfrannu dros y lles cyffredinol',
      'Yn ddeallus ac yn greadigol',
      'Yn poeni’n ddwys am bopeth y maent yn ei wneud',
      'Yn sylweddol sylweddoli posibiliadau',
      'Catalydd ar gyfer troi syniadau yn realiti',
      'Gall wneud llawer o bethau yn agos at y dyddiad cau',
      'Da wrth hyrwyddo newid',
      'Yn cyfrannu’n frwd i undod a chytgord tîm',
    ],
    typeWeakSpots: [
      'Peidio â cheisio perffeithrwydd neu fod yn rhy idealaidd',
      'Bod yn fwy ymarferol',
      'Meddwl am fuddiannau personol pan nad ydynt yn cael eu dal gan eraill',
    ],
    description:
      'Mae’r INFP yn debygol o fod yn gynnes ac yn drugareddol, ac maent yn cael eu gyrru gan achosion sy’n agos at eu calon, gan frwydro dros yr hyn y credant ynddo. Mae gweithio gyda gwerthoedd personol yn hynod bwysig i’r INFP, ac pan nad ydynt yn cael eu gyrru gan idealiad neu chwilio am ystyr dyfnach, maent yn tueddu i oedi a breuddwydio. Mae’r INFP yn debygol o fod yn chwilfrydig ac agored i feddwl, gyda dull hyblyg, ac yn mwynhau gweithio mewn tîm er mwyn helpu i gyflwyno syniadau newydd ac helpu eraill i ddatblygu. Unwaith y maent wedi ymuno â achos y credant ynddo, mae’r INFP yn debygol o fod yn ffyddlon ac yn ymrwymedig iawn.',
    individualTypeByLetters: 'Idealydd',
    individualDescription:
      'Fel Idealydd, mae %fname yn debygol o fod yn berson cynnes a drugareddol, a gyrrir gan achosion sy’n agos at eu calon, gan frwydro dros yr hyn y credant ynddo. Mae gweithio gyda gwerthoedd personol yn hynod bwysig i %fname. Pan nad ydynt yn cael eu gyrru gan idealiad neu chwilio am ystyr dyfnach, mae %fname yn tueddu i oedi a breuddwydio. Mae %fname yn debygol o fod yn chwilfrydig ac agored i feddwl, gyda dull hyblyg, ac yn mwynhau gweithio mewn tîm er mwyn helpu i gyflwyno syniadau newydd ac helpu eraill i ddatblygu. Unwaith y maent wedi ymuno â achos y credant ynddo, mae %fname yn debygol o fod yn ffyddlon ac yn ymrwymedig iawn.',
  },
  INTJ: {
    shortDescription: 'Gwyddonydd',
    atWorkParagraphs: {
      effectiveness: [
        'Derbyn rhwydweithio fel rhan angenrheidiol o’u bywyd proffesiynol, gan gynnwys gwneud cyfarfod cyfeillgar yn weithredol a sgwrs fach weithiau',
        'Bod yn d diplomatic yn y ffordd maent yn mynegi adborth, fel nad yw eraill yn dod yn or-ymwybodol',
        'Peidio â cheisio gwneud popeth eu hunain (hyd yn oed os teimlant y gallent wneud gwell gwaith) ond neilltuo mwy i eraill',
        'Talu sylw i anghenion rhyngbersonol – gan gynnwys eu hunain',
        'Sicrhau eu bod yn rhoi digon o le i eraill roi mewnbwn i’r broses',
        'Cyfathrebu’n glir eu gwerthfawrogi cyfraniadau eraill',
        'Peidio â rhoi gormod o bwyslais ar gael pob gwybodaeth cyn gwneud penderfyniad ond derbyn y gall rhai penderfyniadau fod yn well eu gwneud ar yr eiliad',
      ],
      teamLeader: [
        'Clymu’r tîm gyda syniadau a chrediadau cryf',
        'Helpu’r tîm i ddiffinio’n glir beth maent am ei gyflawni',
        'Sicrhau bod y tîm yn cyflawni ei nod a chadw ar ei lwybr gweithredu',
        'Ysgogi’r tîm trwy osod safonau uchel',
        'Darparu amgylchedd gwaith effeithlon a strwythuredig i’r tîm',
        'Mediadu unrhyw wrthdaro mewn modd gwrthrychol a rhesymegol',
        'Cadw llygad agos ar y Darlun Mawr a chymeradwy newid eu strategaeth os oes angen',
      ],
      teamLeaderFlipSide: [
        'Gellid eu hystyried yn rhy wrthdaro, rhy ganolbwyntio ar dasg neu rhy reoliadol',
        'Gellid hefyd iddynt ymddangos yn rhy wrthryfelgar a thynnu’n ôl',
      ],
      conflicts: [
        'Gallai cael problemau gyda phobl sy’n gadael rhai o’r tasgau cytunwyd arnyn nhw heb eu cwblhau',
        'Gallai fod yn rhwystredig gan bobl nad ydynt yn rhoi digon o sylw neu nad ydynt yn rhoi digon o bwys i’w cwestiynau neu gynigion',
        'Gallai fod yn rhwystredig gan bobl nad ydynt yn ddigon cyflym wrth ddilyn eu syniadau a chynigion',
        'Yn debygol o fod yn rhwystredig gan bobl sy’n canolbwyntio ar fanylion anweddol neu’n mynnu atebion ar unwaith',
      ],
      workEnvironment: [
        'Yn cynnig annibyniaeth',
        'Yn rhoi pwys mawr ar effeithlonrwydd',
        'Yn strwythuredig ac yn ganolbwyntio ar dasgau',
        'Nid yw’n drefnus, ond yn cynnig cyfle i newid a dylunio pethau',
        'Yn creu ysgogiad deallusol',
      ],
      stressAdvisor: [
        'Gall ddod yn fwy anhyblyg, a phroblemau beirniadol yn cynyddu',
        'Gall fod yn glymdra i’w safbwyntiau a barnau, yn anodd derbyn os ydynt yn anghywir',
        'Gall ddod yn amhwyllog ac yn chwilio am gamgymeriadau hyd yn oed os nad oes rhai',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gallant wella eu heffeithlonrwydd yw peidio â cheisio gwneud popeth eu hunain',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      'Efallai y byddant yn teimlo mwyaf cyfforddus wrth ymgymryd â’r rolau canlynol yn eu tîm: Y Precisian, Y Cynhyrchwr Syniadau, Y Beirniad',
    withOthersParagraphs: {
      strengths: [
        'Annibynnol',
        'Amheus',
        'Beirniadol',
        'Safonau uchel o allu a pherfformiad ar eu cyfer a’r rhai eraill',
        'Tawel',
        'Sylwgar',
        'Penderfynol',
        'Egwyddorol',
        'Wrthdaro',
        'Dibynadwy',
        'Meddylgar',
        'Rhesymegol',
      ],
      weakSpotsWithOthers: [
        'Weithiau gall fod yn rhy fewnol',
        'Efallai nad yw deall teimladau eraill bob amser yn dod yn naturiol',
        'Fel rhywun sy’n debygol o fod yn dawel, pan maent yn mynegi eu barn yn gryf gall cydweithwyr fod yn synnu',
        'Gall fod yn wrthryfelgar rhy aml',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'Eu math yw INTJ. Gall eraill ddisgrifio nhw fel persisting, caring, neu friendly',
    typeKeywords: [
      '1. Rhesymegol',
      '2. Medrus',
      '3. Dyletswyddgar',
      '4. Canolbwyntio ar nodau',
      '5. Gyrru',
      '6. Person syniadau',
      '7. Methodolegol',
      '8. Trefnus',
      '9. Dibynadwy',
      '10. Unigol',
      '11. Egwyddorol',
    ],
    typePersonalStrengths: [
      'Da wrth roi cyngor',
      'Yn cyflawni tasgau',
      'Canolbwyntio ar nodau',
      'Yn darparu canlyniadau fel y rhagwelir',
      'Yn cymryd golwg tymor hir ac yn datrys problemau gyda thriniaethau tymor hir',
      'Ymdeimlad cryf o ddyletswydd a chyfrifoldeb',
      'Cryf mewn meddwl systematig a strwythuredig',
      'Cryf wrth ddadansoddiad gwrthrychol a rhesymegol',
      'Gall ddysgu eu hunain',
      'Dull methodolegol a threfnus o ddatrys problemau',
      'Gosod safonau uchel ar eu cyfer a’r rhai eraill',
      'Gall wneud penderfyniadau anodd',
      'Gwerth arloesol',
      'Gall weld pethau trwy',
      'Da wrth ddatblygu theori, modelau, syniadau neu systemau newydd',
      'Da wrth gwblhau tasgau i safon uchel, ar amser',
      'Da wrth gadw at ddulliau a gweithdrefnau sefydledig',
      'Sylwgar i fanylion',
      'Gweithio gyda chysyniadau a systemau damcaniaethol',
      'Dibynadwy',
      'Anffurfyddol',
      'Chwilfrydig yn ysbrydol',
    ],
    typeWeakSpots: [
      'Gall rhwystro eraill trwy ganolbwyntio’n gul ar dasg neu nod penodol',
      'Yn hoffi bod y person sy’n gyfrifol, weithiau cymryd baich trwm na all ei gynnal',
    ],
    description:
      'Mae’r INTJ yn debygol o fod yn gyflym ac yn dychmygus gyda meddwl strategol. Maent yn debygol o fwynhau treulio amser yn meddwl a dadansoddi gwybodaeth mewn modd gofalus ac ystyriol. Mae system a strategaeth yn bwysig i’r INTJ, gyda threfnu a chynllunio yn rhan allweddol o’u helpu i ddeall sut mae pethau’n gweithio. Mae syniadau cryno a phroblemau rhesymegol yn apelio at y INTJ ac maent yn treulio amser yn ystyried ac yn herio’r cysyniadau hyn. Gan ganolbwyntio ar yr hyn sy’n gweladwy a rhesymegol, mae’r INTJ yn meddu ar weledigaeth ac arloesedd ac yn gallu gweithio tuag at y canlyniadau. Nid yw’r INTJ fel arfer yn rhannu eu teimladau gyda phobl eraill yn hawdd.',
    individualTypeByLetters: 'Gwyddonydd',
    individualDescription:
      'Fel Gwyddonydd, mae %fname yn debygol o fod yn gyflym ac yn dychmygus gyda meddwl strategol. Mae %fname yn debygol o fwynhau treulio amser yn meddwl a dadansoddi gwybodaeth mewn modd gofalus ac ystyriol. Mae system a strategaeth yn bwysig iddynt, gyda threfnu a chynllunio yn rhan allweddol o’u helpu i ddeall sut mae pethau’n gweithio. Mae syniadau cryno a phroblemau rhesymegol yn apelio at %fname, sy’n debygol o dreulio amser yn ystyried ac yn herio’r cysyniadau hyn. Gan ganolbwyntio ar yr hyn sy’n gweladwy a rhesymegol, mae %fname yn debygol o fod â gweledigaeth ac arloesedd a’r gallu i weithio tuag at y canlyniadau. Nid yw %fname fel arfer yn rhannu teimladau gyda phobl eraill yn hawdd.',
  },
  INTP: {
    shortDescription: 'Medddyliwr',
    atWorkParagraphs: {
      effectiveness: [
        'Gwneud ymdrech ymwybodol i gysylltu â phobl yn fwy aml',
        'Cydnabod gwerth cymryd rhan mewn sgwrs fach',
        'Defnyddio iaith symlach',
        'Lleihau pethau i ddamcaniaeth resymegol',
        'Ystyried teimladau a theimladau pobl yn fwy aml wrth ddadansoddi problemau a phenderfynu ar dasgau',
        'Dysgu technegau rheoli amser',
        'Canolbwyntio ar ymarferoldeb',
      ],
      teamLeader: [
        'Defnyddio rhesymeg i lywio aelodau’r tîm i’r cyfeiriad cywir',
        'Gosod fframweithiau sy’n galluogi pob aelod o’r tîm i ddefnyddio eu sgiliau',
        'Yn cael ei ystyried yn ffynhonnell gwybodaeth a medrusrwydd, gan weithredu fel adnodd gweithredol i eraill',
        'Gosod yr agenda a chadw eraill yn canolbwyntio ar yr agenda honno',
        'Darparu opsiynau fel y gall penderfyniadau adlewyrchu gwahanol farnau, ac yn ei dro arwain at y datrysiad gorau a mwyaf derbyniol',
        'Yn rhagorol wrth grynhoi a chyffredinoli',
        'Ysgogi eu tîm trwy osod safonau uchel',
      ],
      conflicts: [
        'Yn debygol o fod yn rhwystredig gan aelodau’r tîm sy’n ddi-focws ac nad ydynt yn resymegol yn eu hymagwedd',
        'Yn debygol o gael anhawster gyda aelodau’r tîm sy’n dadlau o ddiffyg gwybodaeth',
        'Yn debygol o fod yn rhwystredig gan aelodau’r tîm sy’n cymryd sylwadau gwrthrychol yn bersonol, ac sy’n cael eu brifo’n hawdd gan yr hyn sy’n resymegol',
        'Yn debygol o gael anawsterau wrth weithio gyda phobl sydd heb weledigaeth nac ymroddiad i’r prosiect',
        'Gallai fod â goddefgarwch isel tuag at bobl sy’n siarad llawer ac yn canolbwyntio ar faterion anrhaid sylw, gan niweidio cenhadaeth ehangach',
      ],
      stressAdvisor: [
        'Gall ddod yn sarhaus ac yn amhwyllog',
        'Gall fwyfwy or-ddadansoddi pethau a chael dadleuon diddiwedd',
        'Gall fod yn glymdra yn eu barnau. Gall ddod yn fwy annibynnol a negyddol',
      ],
      workEnvironment: ['Amgylchedd sy’n annog syniadau a chreadigrwydd', 'Lle mae llai o ymyriadau ac yn cynnwys goruchwyliaeth leiaf'],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gall %fname wella eu heffeithlonrwydd yw drwy wneud ymdrech ymwybodol i gysylltu â phobl yn fwy aml.',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      'Efallai y bydd %fname yn teimlo’n fwy cyfforddus wrth ymgymryd â’r rolau canlynol yn eu tîm: Y Cynhyrchwr Syniadau, Y Beirniad, Y Trefnydd',
    withOthersParagraphs: {
      strengths: [
        'Mwynhau herio eu hunain a phobl eraill',
        'Yn well ganddynt drafod syniadau na sgwrs fach',
        'Agored, meddwl rhydd ac yn goddefgar',
        'Yn gwerthfawrogi rhesymeg a meddwl rhesymegol',
        'Gall fod yn frwdfrydig',
        'Ffrindgar ac yn ddeallus',
        'Meddylgar',
        "Yn well ganddynt gyfathrebu'n ysgrifenedig",
        'Yn debygol o gael ei ystyried yn feddylwr dwfn',
      ],
      weakSpotsWithOthers: [
        'Gall ymddangos yn dawel ac yn wrthryfelgar ar y dechrau',
        'Gall ymddangos yn rhy wrthdaro',
        'Gall ymddangos yn oer a chau',
        'Gall cael ei ystyried yn anmarwol, anhyrwyddus ac yn anghofus',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: 'Eu math yw INTP. Mae rhai allweddeiriau cysylltiedig yn Visionary, Competitive, Analytical',
    typeKeywords: [
      '1. Gweld y dyfodol',
      '2. Medrusrwydd',
      '3. chwilfrydedd',
      '4. Arbenigwr',
      '5. Gwybodus',
      '6. Rhesymegol',
      '7. Brwdfrydig',
      '8. Cystadleuol',
      '9. Meddyliwr',
      '10. Hyblyg',
      '11. Dadansoddol',
      '12. Person Darlun Mawr',
    ],
    typePersonalStrengths: [
      'Da wrth ddefnyddio gwybodaeth',
      'Da wrth ddatrys problemau gyda thriniaethau tymor hir',
      'Perfformiwr uchel',
      'Yn debygol o ddod yn arbenigwr mewn maes penodol',
      'Yn aml yn meddu ar allu anarferol i ddatrys problemau cymhleth yn eu maes o ddiddordeb',
      'Da wrth sylwi patrwmau, cysylltiadau ac yn gweld y Darlun Mawr',
      'Cryf wrth ddatblygu theori, modelau, syniadau neu systemau newydd',
      'Da wrth ddarparu gweledigaeth feirniadol a mewnwelediad deallusol',
      'Cryf wrth ddatrys problemau cysyniadol',
      'Da wrth gasglu data mewn modd amherthnasol',
      'Yn uchel yn ddadansoddol',
      'Creadigol ac yn ddychmygus',
      'Mwynhau holi a beirniadu trefn pethau',
      'Hyblyg ac addasadwy',
      'Mwynhau cyfleoedd i fod yn greadigol',
      'Mwynhau cymhlethdod',
      'Annibynnol',
      'Pensaer newid',
      'Dylunydd systemau',
    ],
    typeWeakSpots: [
      'Dangos llai o amheus a beirniadaeth',
      'Cyfathrebu mwy ac yn agored neu’n ffrindgar',
      'Archwilio diddordebau eraill. Bod mewn gyrfa sy’n galluogi eu diddordebau i gael eu defnyddio’n dda',
      'Derbyn mwy o bobl nad ydynt cystal',
      'Cydymffurfio mwy mewn rhai sefyllfaoedd',
      'Gall weithiau wynebu hunan-amheuaeth',
      'Gall dewis gweithio ar eu pen eu hunain',
      'Da wrth ddod o hyd i atebion creadigol ac arloesol, ond llai brwdfrydig pan fydd yn gyfrifol am weithredu',
    ],
    description:
      'Mae’r INTP yn debygol o fwynhau meddwl a datrys problemau oherwydd eu tuedd i fod â llygad da am fanylion, ac agwedd dda at ddeall syniadau cyffredinol a phroblemau rhesymegol. Mae’r INTP yn debygol o fod yn dawel a meddylgar, gan hoffi cadw eu teimladau i’w hunain. Fel unigolyn gwrthrychol a realistig, maent yn tueddu i fwynhau dadleuon gyda phobl eraill, sy’n eu galluogi i herio ac ddod o hyd i’r gwir, fodd bynnag weithiau gallant ymddangos yn ansicr neu anwybyddu anghenion eraill os ydynt yn rhy brysur gyda’r hyn maent yn ei ystyried yn bwysig.',
    individualTypeByLetters: 'Medddyliwr',
    individualDescription:
      'Fel Medddyliwr, mae %fname yn debygol o fwynhau meddwl a datrys problemau oherwydd eu tuedd i fod â llygad da am fanylion, ac agwedd dda at ddeall syniadau cyffredinol a phroblemau rhesymegol. Mae %fname yn debygol o fod yn dawel a meddylgar, gan hoffi cadw eu teimladau i’w hunain. Fel unigolyn gwrthrychol a realistig, mae %fname yn tueddu i fwynhau dadleuon gyda phobl eraill, sy’n eu galluogi i herio ac ddod o hyd i’r gwir. Fodd bynnag, gall %fname weithiau ymddangos yn ansicr neu anwybyddu anghenion eraill os ydynt yn rhy brysur gyda’r hyn maent yn ei ystyried yn bwysig.',
  },
  ISFJ: {
    shortDescription: 'Maethwr',
    atWorkParagraphs: {
      effectiveness: [
        'Peidio â bod yn rhy sensitif ac yn poeni gormod am gytgord',
        "Canmol eu sgiliau a chyfraniadau eu hunain yn ogystal â sgiliau pobl eraill yn amlach, yn hytrach na'u tanbrisio",
        'Parod i gyfleu neges galed pan fo angen',
        'Peidio â chymryd sylwadau pobl eraill yn rhy ddifrifol neu’n bersonol, ond gadael iddynt basio’n fwy aml',
        'Aros wrth eu barn eu hunain os ydynt yn hyderus eu bod yn gywir, yn hytrach na mynd gyda’r mwyafrif er mwyn cyd-fynd â’r tîm',
      ],
      teamLeader: [
        'Gweithio’n galed ac yn barod bob amser',
        'Tueddfod i fod yn dda wrth wrando ar bob syniad, dod â phawb at ei gilydd a chael cefnogaeth gyffredinol ar gyfer y datrysiad',
        'Cael pobl eraill i weithio gyda’i gilydd o fewn y system a chadw at y rheolau maent wedi’u gosod',
        'Annog eraill i ddatblygu eu sgiliau arweinyddiaeth eu hunain pan fo’n bosibl',
        'Mynnu ar gywirdeb a manwl gywirdeb',
      ],
      conflicts: [
        'Yn debygol o gael eu rhwystro gan aelodau’r tîm sydd, yn eu barn nhw, yn siarad gormod, yn torri neu ddim yn gwrando ar eraill',
        'Yn debygol o gael eu poeni gan aelodau’r tîm sy’n tanbrisio pobl eraill a’u syniadau',
        'Gall fod yn rhwystredig gan bobl sydd, yn eu barn nhw, yn treulio gormod o amser ar agendaau personol ac felly yn esgeuluso tasgau’r tîm a nodau cyfarfodydd',
        'Gall fod â gwrthdaro gyda phobl sydd, yn eu barn nhw, heb synnwyr cyffredin',
        'Yn debygol o gael trafferth gyda phobl sydd, yn eu barn nhw, ddim yn barod i gydweithio neu rannu gwybodaeth berthnasol',
      ],
      stressAdvisor: [
        'Yn cael hi’n anodd dweud na, ac yn dod yn fwy pessimistaidd os nad yw pethau’n mynd yn eu ffordd',
        'Yn dod yn fwy pryderus, ac felly’n dod yn fwy llym yn eu meddwl er mwyn ceisio rheoli’r sefyllfa',
        'Gall deimlo’n ddigalon os na chaiff eu gwneud i deimlo’n werthfawr',
      ],
      workEnvironment: [
        'Mae amgylchedd cytbwys yn well, er mwyn osgoi gwrthdaro',
        'Yn well ganddynt sefydliad strwythuredig gyda rolau a thasgau diffiniedig',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gall %fname wella eu heffeithlonrwydd yw bod yn barod i gyfleu neges galed pan fo angen.',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      'Efallai y bydd %fname yn teimlo’n fwy cyfforddus wrth ymgymryd â’r rolau canlynol yn eu tîm: Y Cynhyrchwr Manwl, Y Trefnydd, Y Beirniad',
    withOthersParagraphs: {
      strengths: [
        'Ffrindgar ac atebol',
        'Ystyriol a gofalgar, ac ar gael bob amser pan fo eraill angen eu cymorth',
        'Cynhesrwydd tawel a hiwmor caredig',
        'Cofio manylion am bobl sydd o bwys iddynt',
        'Da wrth lliniaru gwrthdaro',
        'Tawel, ystyriol ac empathig',
        'Yn poeni am sut mae pobl eraill yn teimlo',
        'Yn hoff o fod yn fanwl gywir mewn sgwrsion, ac yn disgwyl yr un peth gan eraill',
      ],
      weakSpotsWithOthers: [
        'Awydd uchel am sefydlogrwydd',
        'Gall fod yn rhy sensitif',
        'Gall ganolbwyntio gormod ar y presennol',
        'Gwrthod cryf tuag at wrthdaro, felly dewisiad cryf am berthnasoedd cytbwys',
        'Sensitif i deimladau eraill a hwyl tîm',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "Mae math %fname yn cael ei alw'n ISFJ. Mae rhai allweddeiriau cysylltiedig yn Ymarferol, Trefnus, Manwl Gywir",
    typeKeywords: [
      '1. Ymarferol',
      '2. Systematig',
      '3. Dibynadwy',
      '4. Realistaidd',
      '5. Gofalgar',
      '6. Sensitif',
      '7. Manwl',
      '8. Trefnus',
      '9. Penderfynol',
      '10. Ffrindgar',
      '11. Sefydlog',
      '12. Manwl Gywir',
    ],
    typePersonalStrengths: [
      'Parod i wneud yr hyn sydd angen ei wneud bryd hynny',
      'Ymarferol gyda synnwyr cyffredin da',
      'Da wrth gwblhau tasgau i safon uchel',
      'Yn cymryd gwaith o ddifrif ac yn meddu ar ymdeimlad cryf o gyfrifoldeb',
      'Gwyliwr realistaidd o’r amgylchedd',
      'Yn well ganddynt ddysgu trwy wneud',
      'Sylw cryf at fanylion',
      'Cof da a gorchymyn cryf o ffeithiau',
      'Yn amyneddgar wrth gasglu manylion angenrheidiol',
      'Sgiliau trefnu da',
      'Yn rhoi sefydlogrwydd i unrhyw brosiect neu grŵp',
      'Dull systematig, trylwyr',
      'Penderfynol',
      'Yn ffyddlon iawn pan fyddant yn teimlo eu bod yn perthyn',
      'Da wrth greu trefn',
      'Da wrth ddarparu gwybodaeth gefndir yn ymatebol ac yn gyfrifol',
    ],
    typeWeakSpots: [
      'Ceisio bod yn fwy agored neu ffrindgar',
      'Bod yn fwy derbyniol tuag at wrthdaro a pheidio â cheisio cyd-fynd bob amser',
      'Peidio â bod mor ddibynnol ar awdurdod',
      'Derbyn mwy o newidiadau',
      'Cydnabod eu bod weithiau’n anghyfforddus gyda cham-drefn ac ansicrwydd',
    ],
    description:
      'Mae’r ISFJ yn debygol o fod yn unigolyn gofalgar a charedig sydd eisiau teimlo’n ddefnyddiol ac yn helpgar. Maent yn ymroddedig ac yn amyneddgar; rhywun na fydd yn rhoi’r gorau ar y cam cyntaf. Fodd bynnag, maent yn debygol o fod yn eithaf swil ac yn dawel. Mae’r ISFJ yn ystyried eraill cyn eu hunain ac yn rhoi cymorth ymarferol a ffrindgar, gan wella dull personol. Maent yn hoff o ofalu am fanylion ymarferol dydd i ddydd, ac yn osgoi tynnu sylw atynt eu hunain.',
    individualTypeByLetters: 'Maethwr',
    individualDescription:
      'Fel Maethwr, mae %fname yn debygol o gael ei ystyried yn unigolyn gofalgar a charedig. Mae %fname eisiau teimlo’n ddefnyddiol ac yn helpgar, ac yn debygol o fod yn ymroddedig ac amyneddgar; rhywun na fydd yn rhoi’r gorau ar y cam cyntaf. Mae %fname yn debygol o fod yn eithaf swil ac yn dawel, gan ystyried eraill cyn eu hunain, ac yn rhoi cymorth ymarferol a ffrindgar, gan wella dull personol. Mae %fname yn debygol o ofalu am fanylion ymarferol dydd i ddydd ac yn osgoi tynnu sylw atynt eu hunain.',
  },
  ISFP: {
    shortDescription: 'Artist',
    atWorkParagraphs: {
      effectiveness: [
        'Peidio â bod yn rhy eiddigeddol a derbyn clod pan fo’n ddyledus',
        'Peidio â thanbrisio eu sgiliau a chyfraniadau eu hunain',
        'Peidio â chymryd sylwadau pobl eraill mor ddifrifol, gan gydnabod nad yw rhai pobl yn meddwl cyn siarad',
        'Parhau i fod yn bleserus, tra’n dysgu sut i ddangos cryfder pan fo angen',
        'Peidio â phoeni gormod am gytgord',
        'Dysgu sut i gyfleu neges galed pan fo angen',
        'Peidio â bod mor hunan- feirniadol',
        'Dysgu technegau rheoli amser',
        "Dysgu sut i ddweud 'Na'",
        'Ymarfer rhoi adborth negyddol',
      ],
      teamLeader: [
        'Yn ysbrydoli eraill i ddilyn eu cod o weithio’n galed a bod bob amser yn barod',
        'Yn gwrando’n ofalus ar bob syniad a phryder, ac yna’n sicrhau cefnogaeth gyffredinol ar gyfer ateb gyda pherswâd ysgafn ond effeithiol',
        'Yn dangos diddordeb diffuant mewn safbwyntiau eraill',
        'Yn caniatáu i eraill radd uchel o ryddid i osod eu targedau eu hunain',
        'Dim ond yn symud ymlaen gyda phenderfyniadau os cyrhaeddwyd cydsyniad',
      ],
      conflicts: [
        'Yn debygol o gael eu rhwystro gan bobl sy’n siarad gormod',
        'Yn debygol o wrthdaro gyda phobl sy’n tanbrisio pobl eraill a’u syniadau',
        'Gall fod yn rhwystredig gan bobl sydd heb synnwyr cyffredin',
        'Gall fod yn drist gan bobl sy’n rhwystro’r tîm drwy beidio â rhannu gwybodaeth berthnasol',
        'Dydy hi ddim yn gwerthfawrogi pobl hunanol nad ydynt am gydweithio',
      ],
      stressAdvisor: [
        'Gall dod yn fwy anghyson, gyda trafferth rheoli amser ac yn gadael i eraill gymryd rheolaeth i osgoi cyfrifoldeb',
        'Gall gymryd beirniadaeth yn bersonol, hyd yn oed os yw’n wahanol o safbwynt barn',
        'Yn cymryd amser i benderfynu, gan newid eu meddwl yn aml',
      ],
      workEnvironment: [
        'Amgylchedd hyblyg gyda goruchwyliaeth leiaf',
        'Yn well ganddynt le cefnogol a phwrpasol er mwyn teimlo’n gartrefol',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gall %fname wella eu heffeithlonrwydd yw peidio â thanbrisio eu sgiliau a chyfraniadau eu hunain.',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      'Efallai y bydd %fname yn teimlo’n fwy cyfforddus wrth ymgymryd â’r rolau canlynol yn eu tîm: Y Canolwr, Y Trefnydd, Y Cynhyrchwr Manwl',
    withOthersParagraphs: {
      strengths: [
        'Yn dawel, yn ffrindgar, cynnes ac yn gefnogol',
        'Yn ffyddlon ac yn ymroddedig i’r bobl sydd o bwys',
        'Sensitif',
        'Yn garedig',
        'Agored i feddwl',
        'Yn dangos hiwmor ysgafn',
        'Heb fod yn feirniadol na barnus',
        'Yn ystyriol',
        'Heb feirniadu eraill yn ddiangen',
        'Heb orfodi eu barn neu werthoedd ar eraill',
      ],
      weakSpotsWithOthers: [
        'Gall gymryd ychydig o amser i agor at bobl newydd',
        'Yn osgoi anghytgord',
        'Yn ymosodol',
        'Heb fod yn fwy llafar neu hyderus',
        'Gall tynnu’n ôl oddi wrth bobl mewn sefyllfa o straen',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "Mae math %fname yn cael ei alw'n ISFP. Mae rhai allweddeiriau cysylltiedig yn Ymarferol, Ystyriol, Hyblyg",
    typeKeywords: [
      '1. Ymarferol',
      '2. Agored i feddwl',
      '3. Annibynnol',
      '4. Tosturiol',
      '5. Cadarnhaol',
      '6. Ystyriol',
      '7. Hamddenol',
      '8. Ymarferol',
      '9. Hyblyg',
      '10. Realistaidd',
      '11. Ffyddlon',
    ],
    typePersonalStrengths: [
      'Yn hoffi gweithredu yn hytrach na siarad',
      'Yn poeni am ddod o hyd i atebion ymarferol a chadarn i broblemau realiti',
      'Tosturiol, agored i feddwl ac yn derbyn safbwyntiau eraill',
      'Gall weithio’n annibynnol ac yn eu hamser eu hunain',
      'Hyblyg ac addasol, heb glymu at syniadau hen ffasiwn',
      'Yn ffyddlon ac yn ymroddedig',
      'Da wrth wneud i eraill weithio gyda’i gilydd o fewn y system',
      'Da wrth ddarparu gwybodaeth gefndir yn ymatebol ac yn gyfrifol',
      'Yn mwynhau profiad ymarferol',
      'Realistaidd',
      'Da wrth ymateb i argyfyngau a datrys problemau',
      'Ystyriol ac yn rhagweld effaith gweithredoedd ar bobl eraill',
      'Annibynnol yn feddylgar',
      'Agwedd gadarnhaol',
      'Da wrth fod yn gynhwysol a lliniaru gwrthdaro',
      'Yn hoff o weithio’n gyfartal',
      'Yn dal gwerthoedd a delfrydau cryf',
      'Da wrth gyfathrebu un-i-un',
      'Da wrth weld y darlun ehangach',
      'Parod i dorri rheolau pan fo angen',
      'Da wrth arsylwi’n ddofn',
    ],
    typeWeakSpots: [
      'Cael mwy o gyflymder wrth wneud pethau',
      'Bod yn fwy agored neu rannu meddyliau',
      'Gwerthfawrogi mwy o anghytgordau a gwrthdaro. Ceisio peidio bob amser â cheisio cyfaddawdu a chydsyniad',
      'Gwerthfawrogi trefn a rheoliadau, a llai o ryddid neu le',
      'Bod yn llai eiddigeddol am eu gallu',
      'Cymerwch y cam cyntaf yn fwy',
      'Talwch fwy o sylw i fanylion',
    ],
    description:
      'Mae’r ISFP yn unigolyn hamddenol, tawel a ffrindgar. Maent yn gydweithredol, gan hoff leoliad cefnogol i hybu cytgord tîm. Yn weithgar, maent yn well wrth weithgareddau ymarferol i roi eu creadigrwydd ar waith, fodd bynnag maent yn debygol o osgoi gweithgareddau trefnu a chynllunio, gan ddewis dull mwy hyblyg a gonest ac osgoi rhagweld y dyfodol. Fel gwrandawyr da, yn amyneddgar a sensitif i anghenion eraill, byddant yn rhoi cyngor ymarferol a chymorth lle bo’n bosibl.',
    individualTypeByLetters: 'Artist',
    individualDescription:
      'Fel Artist, mae %fname yn debygol o fod yn unigolyn hamddenol, tawel a ffrindgar. Mae %fname yn tueddu i gydweithio, gan fwynhau rôl gefnogol i hybu cytgord tîm. Mae %fname yn fwy gweithredol, gan ffafrio gweithgareddau ymarferol i roi eu creadigrwydd ar waith. Fodd bynnag, maent yn debygol o osgoi gweithgareddau trefnu a chynllunio, gan ddewis dull mwy hyblyg a gonest, gan osgoi gwneud cynlluniau’r dyfodol. Mae %fname yn gwrandäwr da, yn amyneddgar ac yn sensitif i anghenion eraill, ac yn gyfforddus wrth roi cyngor ymarferol a chymorth pan fo’n bosibl.',
  },
  ISTJ: {
    shortDescription: 'Arolygydd',
    atWorkParagraphs: {
      effectiveness: [
        'Sicrhau eu bod yn cadw pobl yn hysbys ac yn gyfoes',
        'Datblygu eu sgiliau rhwydweithio',
        'Ceisio creu eiliadau pleserus yn ystod y diwrnod gwaith',
        'Cydnabod gwerth sgwrs fach',
        'Gofyn am adborth yn amlach',
        'Annog a gwerthfawrogi creadigrwydd',
        'Datblygu sgiliau cyfathrebu rhyngbersonol',
        'Atgoffa eu hunain i beidio â bod mor gyffyrddus â manylion unigol nes colli ystyr cyffredinol y dasg',
        'Edrych y tu hwnt i systemau sefydledig',
        'Drosglwyddo mwy a llai o fonitro manwl',
        'Cymryd rhan mewn sgyrsiau ar ddechrau proses, ac cynnig eu safbwyntiau yn gynnar yn hytrach na disgwyl tan yn rhy hwyr.',
        'Darparu barn feirniadol yn ystod cysyniadau syniadau',
      ],
      teamLeader: [
        'Yn creu ymddiriedaeth yn eu tîm gyda dadleuon rhesymegol, gwybodaeth fanwl am eu pwnc ac agwedd realistig',
        'Yn agored i ffeithiau a dadleuon rhesymegol',
        'Trefnu ac yn cynnal strwythur effeithiol heb orfod dweud gormod',
        'Yn cynnal cyfarfodydd effeithlon a chanolbwyntiedig',
        'Yn glir gyda’r hyn a ddisgwylir, pa dasgau sydd angen eu cwblhau a pha safon',
      ],
      conflicts: [
        'Yn debygol o gael eu rhwystro gan aelodau’r tîm sy’n rhy sgwrslyd',
        'Gall fod yn rhwystredig gan bobl sy’n cael eu hystyried yn anhyderus ac heb ddilyn drwodd',
        'Yn debygol o gael goddefgarwch isel tuag at bobl sy’n eisiau trafod materion rhyngbersonol neu anrhyngberthol yn y gwaith',
      ],
      stressAdvisor: [
        'Gall ddod yn ganolog a anhyblyg, gan ofyn i reolau a strwythurau gael eu dilyn',
        'Gall fod yn anodd derbyn eu bod yn gallu bod yn anghywir, a hefyd ddim yn rhoi digon o glod i eraill pan fo’n haeddiannol',
        'Gall dod yn negyddol ac yn or-brysur wrth ystyried manylion',
      ],
      workEnvironment: [
        'Yn well ganddynt waith gyda nodau a gweithdrefnau clir yn eu lle',
        'Yn well ganddynt weithio ar un tasg neu brosiect ar y tro, gyda goruchwyliaeth leiaf',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gall %fname wella eu heffeithlonrwydd yw cydnabod gwerth sgwrs fach',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      'Efallai y bydd %fname yn teimlo’n fwy cyfforddus wrth ymgymryd â’r rolau canlynol yn eu tîm: Y Beirniad, Y Manwl, Y Trefnydd',
    withOthersParagraphs: {
      strengths: [
        'Yn gwerthfawrogi traddodiadau a ffyddlondeb',
        'Syniad o ddyletswydd',
        'Daearol',
        'Oer, ac annibynnol',
        'Yn ddibynadwy ac yn hyderus',
        'Parod i fod yn gymorth',
        'Yn gadarn yn eu barnau',
        "Yn well ganddynt gyfathrebu'n ysgrifenedig yn hytrach na chael trafodaethau hir",
        'Yn trin pobl gyda pharch',
      ],
      weakSpotsWithOthers: [
        'Gall ymddangos yn wrthryfelgar a heb emosiwn',
        'Ddim yn bersonol, yn well ganddynt gyflawni tasgau na mynychu pleserau rhyngbersonol',
        'Anodd cysylltu a chyfateb yn emosiynol',
        'Gall ymddangos yn ddi-feddwl ac yn anhyblyg',
        'Araf i addasu a ymateb i newid',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "Mae math %fname yn cael ei alw'n ISTJ. Mae rhai allweddeiriau cysylltiedig yn sefydlog, gwrthrychol, penderfynol",
    typeKeywords: [
      '1. Manwl',
      '2. Penderfynol',
      '3. Rhesymegol',
      '4. Cyfrifol',
      '5. Parchus',
      '6. Sefydlog',
      '7. Manwl',
      '8. Dibynadwy',
      '9. Systematig',
      '10. Ffrindgar',
      '11. Gwybodus',
      '12. Gwrthrychol',
    ],
    typePersonalStrengths: [
      'Trefnus ac wedi’i drefnu, gartref ac yn y gwaith',
      'Dull cyfrifol o waith',
      'Yn ymroddedig i gyflawni tasgau',
      'Yn cwblhau tasgau’n drylwyr',
      'Golwg realistig, ymarferol',
      'Da wrth ddatrys problemau gyda synnwyr cyffredin',
      'Yn gweithio’n gyson tuag at gyrraedd nodau, waeth beth fo’r tynnu sylw',
      'Penderfynol',
      'Gwrthrychol a rhesymegol',
      'Sgiliau dadansoddol cryf',
      'Yn ymroddedig i bobl a’r sefydliad y maent yn rhan ohono',
      'Disgybledig ac yn mwynhau datblygu a dilyn trefn',
      'Manwl ac yn gorchymyn gwych o ffeithiau',
      'Sylw ardderchog i fanylion',
      'Parod i weithio’n annibynnol',
      'Yn gwerthfawrogi dilyn prosesau a gweithdrefnau sefydledig',
      'Da wrth orfodi rheolau a pholisïau',
      'Da wrth ddogfennu gweithdrefnau a gwybodaeth',
      'Yn hoffi gwella pethau trwy gamau bach',
      'Safonau uchel. Da wrth nodi a chywiro camgymeriadau',
      'Da wrth ddod â chyfrifoldeb uchel i unrhyw dîm',
      'Gweithgar, ac yn ysbrydoli eraill i weithio’n galed i gyflawni’r dasg ar amser',
    ],
    typeWeakSpots: [
      'Gwerthfawrogi neu dderbyn mwy o ansicrwydd a di-order',
      'Derbyn mwy o newidiadau a arloesi',
      'Bod yn llai caeth i reolau',
    ],
    description:
      'Mae’r ISTJ yn unigolyn systematig, sy’n arbennig o ffyddlon ac yn ddibynadwy. Maent yn ymfalchïo yn y gwaith a wneir ganddynt, ac yn gyfforddus gyda tasgau rheolaidd. Mae ISTJ yn bobl difrifol a thwyllodrus, sy’n mwynhau creu a gorfodi trefn. Maent yn debygol o fod yn fanwl, systematig ac yn gyfrifol, gan fwynhau delio â ffeithiau. Mae cyfrifoldebau yn cael eu croesawu, ac mae’r ISTJ yn cymryd rheolaeth ar y dasg dan sylw, gan gadw at dymhorau ac heb fod yn goddefgar i ansicrwydd a diogelwch. Mae dyletswydd yn bwysig i’r ISTJ ac unwaith y byddant wedi ymrwymo i brosiect, byddant yn dilyn ymlaen gyda gweithredoedd, gan sicrhau bod penderfyniadau yn seiliedig ar ffeithiau a rhesymeg.',
    individualTypeByLetters: 'Arolygydd',
    individualDescription:
      'Fel Arolygydd, mae %fname yn debygol o fod yn unigolyn systematig, sy’n arbennig o ffyddlon ac yn ddibynadwy. Mae %fname yn ymfalchïo yn y gwaith a wneir ganddynt, ac yn gyfforddus gyda tasgau rheolaidd. Efallai y bydd %fname yn cael ei ystyried yn berson difrifol a thwyllodrus, sy’n mwynhau creu a gorfodi trefn; mae’n debygol o fod yn fanwl, systematig, cyfrifol, ac yn mwynhau delio â ffeithiau. Mae %fname yn croesawu cyfrifoldebau a’n cymryd rheolaeth ar y dasg dan sylw, gan gadw at dymhorau ac heb fod yn goddefgar i ansicrwydd a diogelwch. Mae dyletswydd yn bwysig iddynt ac unwaith y byddant wedi ymrwymo i brosiect, maent fel arfer yn dilyn ymlaen gyda gweithredoedd, gan sicrhau bod penderfyniadau yn seiliedig ar ffeithiau a rhesymeg.',
  },
  ISTP: {
    shortDescription: 'Mecanydd',
    atWorkParagraphs: {
      effectiveness: [
        'Gofalu nad yw’n gweithio ar ormod o dasgau ar yr un pryd. Cwblhau tasgau allweddol cyn symud ymlaen i rywbeth newydd',
        'Bod yn llai penodol am fanylion penodol',
        'Gofalu nad yw’n rhoi’r argraff i eraill eu bod yn ddi-ffordd',
        'Canolbwyntio eu egni ar ddatrys un argyfwng ar y tro',
        'Sefydlu strwythur caeedig sy’n cyfyngu opsiynau gweithredu',
        'Treulio mwy o amser yn paratoi ymlaen llaw',
        'Paratoi agenda ar gyfer cyfarfodydd',
        'Ymarfer eu sgiliau rhwydweithio',
        'Ystyried anghenion rhyngbersonol cydweithwyr yn fwy aml',
        'Cadw mwy o sylw i fanylion',
        'Cydnabod gwerth sgwrs fach',
      ],
      teamLeader: [
        'Yn cymryd dull pragmatig o arweinyddiaeth',
        'Yn arwain y tîm gyda awdurdod distaw, anuniongyrchol',
        'Yn gwerthuso pob safbwynt, ond gyda’r bwriad clir o symud i weithredu',
        'Yn annog y tîm i barhau',
        'Yn delio ag argyfyngau a newid yn dda iawn',
        'Yn gwybod ble i gael y wybodaeth angenrheidiol',
        'Yn datrys problemau trwy gymhwyso rhesymeg a edrych ar y ffeithiau yn gyntaf',
      ],
      conflicts: [
        'Yn debygol o gael trafferth gweithio gyda aelodau tîm y maent yn eu hystyried yn rhy emosiynol yn hytrach na gwrthrychol',
        'Yn debygol o gael trafferth gyda phobl y maent yn eu hystyried yn gwastraffu egni gwerthfawr ar dasgau y tu allan i gylch gwaith y tîm',
        'Gall fod yn rhwystredig gan aelodau tîm sy’n cynnal cyfarfodydd gwybodaeth yn aml, lle nad yw’r diben ymarferol yn glir',
      ],
      stressAdvisor: [
        'Gall fod yn dueddol i ymatebion emosiynol ac ysgafn os o dan bwysau a straen',
        'Gall fod yn anodd dilyn drwodd a chwblhau tasg',
        'Gorfodir gan ganolbwyntio gormodol ar fanylion presennol, heb ystyried posibiliadau yn y dyfodol',
      ],
      workEnvironment: [
        'Yn ceisio hyblygrwydd yn y drefn ac angen goruchwyliaeth leiaf gan eu bod yn hoffi gweithredu’n spontanaidd',
        'Mwynhau chwarae gyda syniadau a dod o hyd i ffyrdd newydd o ddatrys pethau',
      ],
    },
    atWorkTagLine: '---',
    atWorkSneakPeek: 'Un ffordd y gall %fname wella eu heffeithlonrwydd yw bod yn llai canolbwyntio ar y manylion',
    withOthersTagLine: '---',
    withOthersSneakPeek:
      'Efallai y bydd %fname yn teimlo’n fwy cyfforddus wrth ymgymryd â’r rolau canlynol yn eu tîm: Y Beirniad, Y Manwl, Y Trefnydd',
    withOthersParagraphs: {
      strengths: [
        'Tystlon ac agored o feddwl',
        'Fflachiadau annisgwyl o hiwmor gwreiddiol',
        'Yn tueddu i ddadansoddi bywyd gyda chwilfrydedd',
        'Mwynhau byw bywyd yn y presennol',
        'Yn gweithgar ac yn spontanaidd',
        'Caru hwyl',
        'Dyfnach',
        'Yn ystyriol',
        'Yn myfyrio',
        'Annibynnol',
        'Efallai’n well ganddynt gyfathrebu’n ysgrifenedig',
        'Teg ac wrthrychol',
      ],
      weakSpotsWithOthers: [
        'Gall ymddangos yn rhy benderfynol',
        'Gall deimlo’n gyfyngedig yn rhy hawdd',
        'Gall eistedd yn ôl yn gychwynnol cyn bod yn barod i gyfrannu',
        'Bydd pobl fwy emosiynol yn cael trafferth gyda’u dull rhesymegol iawn',
        'Gall ymddangos yn wrthryfelgar',
      ],
    },
    typeTagLine: '--',
    typeSneakPeek: "Mae math %fname yn cael ei alw'n ISTP. Mae rhai allweddeiriau cysylltiedig yn wrthrychol, rhesymegol, neu dderbyniol",
    typeKeywords: [
      '1. Daearol',
      '2. Rhesymegol',
      '3. Dadansoddol',
      '4. Ffeithiol',
      '5. Addasadwy',
      '6. Pragmatig',
      '7. Tystlon',
      '8. Annibynnol',
      '9. Wrthrychol',
      '10. Teg',
      '11. Datrys problemau',
    ],
    typePersonalStrengths: [
      'Da wrth ddeall sut mae pethau’n gweithio',
      'Da wrth symud y tîm i weithredu',
      'Canolbwynt cryf ar atebion ymarferol',
      'Datrys problemau naturiol: yn gyflym wrth ddod o hyd i atebion gweithredadwy i broblemau',
      'Da wrth ddefnyddio sgiliau dadansoddol i drefnu gwaith yn effeithlon',
      'Hyblygrwydd ac addasadwy',
      'Da wrth drefnu ffeithiau a defnyddio egwyddorion rhesymegol',
      'Dull pragmatig, realistig a ymarferol',
      'Gallu rhesymegol cryf',
      'Da wrth gynllunio',
      'Parod am gyffro ac anturiaethau',
      'Da wrth ymateb i argyfyngau',
      'Yn gwerthfawrogi rhesymeg a meddwl rhesymegol',
      'Parod i weithredu',
      'Ymatebol ac yn benderfynol',
      'Da wrth weithio’n annibynnol',
      'Parod i dorri rheolau os nad yw’n gwneud synnwyr',
      'Realist sy’n canolbwyntio ar atebion',
      'Cysurus wrth weithio gyda ffeithiau a data caled',
    ],
    typeWeakSpots: [
      'Ceisio peidio â sefyll yn ôl a sylwi yn unig',
      'Ceisio ymddangos yn llai pell',
      'Peidio ag anwybyddu trefnau wrth geisio amrywiaeth a chyffro',
      'Dangos mwy o ddiddordeb mewn damcaniaethau rhagarweiniol',
    ],
    description:
      'Mae ISTP yn debygol o gael eu tynnu at rôl sydd angen gweithredu. Maent yn tueddu i fod yn ymarferol, ac yn frwdfrydig ac yn egniol am brosiect. Mae ISTP yn unigolyn eithaf hamddenol, yn dewis hyblygrwydd yn hytrach na threfn, gan ganiatáu i’w chwilfrydedd eu harwain i lefydd newydd. Maent yn rhesymegol ac ymarferol, gyda thristwch am wybodaeth, ac nid ydynt yn gyfforddus gyda chynllunio a threfnu, gan ddewis dull mwy hyblyg.',
    individualTypeByLetters: 'Mecanydd',
    individualDescription:
      'Fel Mecanydd, mae %fname yn debygol o gael eu tynnu at rôl sydd angen gweithredu. Mae %fname yn hoffi bod yn ymarferol, ac yn frwdfrydig ac yn egniol am brosiect. Maent yn unigolyn eithaf hamddenol, yn dewis hyblygrwydd yn hytrach na threfn, gan ganiatáu i’w chwilfrydedd eu harwain i lefydd newydd. Mae %fname yn rhesymegol ac ymarferol, gyda thristwch am wybodaeth ac nid yn gyfforddus gyda chynllunio neu drefnu. Mae %fname yn dewis dull mwy hyblyg.',
  },
};

export const tmiTypeGroupsCy: { name: string; types: string[] }[] = [
  {
    name: 'Crefftwyr',
    types: ['ISFP', 'ESTP', 'ESFP', 'ISTP'],
  },
  {
    name: 'Gwarcheidwyr',
    types: ['ESTJ', 'ISTJ', 'ESFJ', 'ISFJ'],
  },
  {
    name: 'Idealiaid',
    types: ['ENFJ', 'INFJ', 'ENFP', 'INFP'],
  },
  {
    name: 'Rheolwyr Rhesymegol',
    types: ['ENTJ', 'INTJ', 'ENTP', 'INTP'],
  },
];

export const spectrumTraitsCy: {
  [trait: string]: {
    imageUrl: string;
    left: {
      title: string;
      description: string;
    };
    right: {
      title: string;
      description: string;
    };
  };
} = {
  OPPORTUNITY_AWARENESS: {
    imageUrl: lightningImageUrl,
    left: {
      title: 'Ymwybod am gyfle',
      description: 'Yn adnabod posibiliadau a chyfleoedd',
    },
    right: {
      title: 'Categoriol',
      description: 'Yn gweld pethau fel pendant a chlir',
    },
  },
  ACTION_ORIENTATION: {
    imageUrl: lightningImageUrl,
    left: {
      title: 'Yn gweithredu',
      description: 'Ymunwr hunan-gymhellol, egniol, yn dechrau gweithredu',
    },
    right: {
      title: 'Amheus',
      description: 'Ystyried cyn gweithredu, amyneddgar',
    },
  },
  DRIVE: {
    imageUrl: lightningImageUrl,
    left: {
      title: 'Derbynol',
      description: 'Rheolaidd, llai gofynol',
    },
    right: {
      title: 'Gyrru at gyflawniad',
      description: 'Bwrpasol, heriol, pwysau uchel',
    },
  },
  SELF_EFFICACY: {
    imageUrl: lightningImageUrl,
    left: {
      title: 'Poenus',
      description: 'Efallai y bydd yn gweld nodau heriol fel allan o gyrraedd ac amhosibl eu cyflawni',
    },
    right: {
      title: 'Hyderus',
      description: 'Yn credu yn ei allu i wynebu heriau newydd',
    },
  },
  PERSISTENCE: {
    imageUrl: courtImageUrl,
    left: {
      title: 'Ar unwaith',
      description: 'Chwilio am fuddugoliaethau cyflym ac ymarferol',
    },
    right: {
      title: 'Parhaus',
      description: 'Yn dilyn tasgau anodd, efallai yn anghofio’r presennol',
    },
  },
  ORDERLINESS: {
    imageUrl: courtImageUrl,
    left: {
      title: 'Prydlon',
      description: 'Da iawn wedi’i drefnu, wedi cynllunio, trefnus',
    },
    right: {
      title: 'Hyblyg',
      description: 'Yn y ffordd hawsaf, pragmatig, addasol',
    },
  },
  CAUTIOUSNESS: {
    imageUrl: courtImageUrl,
    left: {
      title: 'Ymatebol',
      description: 'Diogel, gofalus, traddodiadol, arferol',
    },
    right: {
      title: 'Ymosodol',
      description: 'Arbrofol, heriol, peryglus, anffurfiol',
    },
  },
  DUTIFULNESS: {
    imageUrl: courtImageUrl,
    left: {
      title: 'Dyletswyddol',
      description: "Cwblhau tasgau'n ddiwyd, dilyn rheolau",
    },
    right: {
      title: 'Addasol',
      description: "Yn ystyried dyletswyddau'n fwy hyblyg ac agored i addasiad",
    },
  },
  ALTRUISM: {
    imageUrl: shuffleImageUrl,
    left: {
      title: 'Altrwistaidd',
      description: 'Caredig, hael, er lles cyffredin',
    },
    right: {
      title: 'Cywir',
      description: "Fel am fel, 'ffafr am ffafr', cyfnewid cyfartal",
    },
  },
  COOPERATION: {
    imageUrl: shuffleImageUrl,
    left: {
      title: 'Cydweithredol',
      description: 'Cytûnol, yn cyfaddasu, yn hyblyg',
    },
    right: {
      title: 'Cystadleuol',
      description: 'Penderfynol, llai parod i gyfaddasu',
    },
  },
  ETHICS: {
    imageUrl: shuffleImageUrl,
    left: {
      title: 'Rhyddfrydol',
      description: 'Naturiol, gonest, heb angen arddangos ffug',
    },
    right: {
      title: 'Gofalus',
      description: 'Gwyliedig, moesol, cred bod rhyw faint o ffug yn angenrheidiol',
    },
  },
  ASSERTIVENESS: {
    imageUrl: peopleImageImageUrl,
    left: {
      title: 'Ystyriol',
      description: 'Penderfynol, yn egluro eu safbwyntiau',
    },
    right: {
      title: 'Mewn rheolaeth',
      description: 'Penderfynol, yn egluro eu safbwyntiau',
    },
  },
  EMOTIONALITY: {
    imageUrl: compassImageUrl,
    left: {
      title: 'Tosturiol',
      description: 'Dangos cydymdeimlad gyda theimladau eraill, gofalus',
    },
    right: {
      title: 'Tawel',
      description: 'Heb gael ei effeithio gan deimladau, didostur',
    },
  },
  GROUNDEDNESS: {
    imageUrl: compassImageUrl,
    left: {
      title: 'Ymarferol',
      description: 'Tangiadwy, concrid, sefydlog, clir',
    },
    right: {
      title: 'Yn chwilfrydig yn ddeallusol',
      description: 'Cysyniadol, cymhleth, mwynhau dadl, meddwl yn gryno',
    },
  },
  IMAGINATION: {
    imageUrl: lightBulbImageUrl,
    left: {
      title: 'Cyfyngedig',
      description: 'Methodolegol, awtomataidd, llai creadigol',
    },
    right: {
      title: 'Creadigol',
      description: 'Creadigol, chwaraegar, yn canolbwyntio ar syniadau',
    },
  },
  FRIENDLINESS: {
    imageUrl: peopleImageImageUrl,
    left: {
      title: 'Difrifol',
      description: 'Difrifol, efallai y caiff ei ystyried yn llai hygyrch',
    },
    right: {
      title: 'Cyfeillgar',
      description: 'Hygyrch, hawdd i ddelio â',
    },
  },
  INDIVIDUALITY: {
    imageUrl: peopleImageImageUrl,
    left: {
      title: 'Trefn y grŵp',
      description: "Mae'n haws 'fitio i mewn', ac yn cadw at ymddygiad y grŵp",
    },
    right: {
      title: 'Unigol',
      description: 'Annibynnol, hunan-ddibynnol, unigryw',
    },
  },
  SOCIABILITY: {
    imageUrl: peopleImageImageUrl,
    left: {
      title: 'Preifat',
      description: 'Mwynhau amser ar eu pen eu hunain, yn wrthryfelgar',
    },
    right: {
      title: 'Cymdeithasol',
      description: 'Allanol, siaradus, mwynhau sŵn cymdeithasol',
    },
  },
};
